var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _g4, _g5, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 345,
    viewBox: "0 0 406 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M174.501 236.736C174.501 254.138 200.289 269.622 232.09 271.333C263.89 273.044 289.678 260.307 289.678 242.905C289.678 225.503 263.89 210.019 232.09 208.308C200.276 206.611 174.501 219.334 174.501 236.736Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M175.498 236.792C175.498 253.89 200.828 269.111 232.089 270.781C263.35 272.451 288.679 259.948 288.679 242.85C288.679 225.752 263.35 210.53 232.089 208.861C200.828 207.191 175.498 219.694 175.498 236.792Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M176.496 236.849C176.496 253.644 201.38 268.603 232.075 270.245C262.77 271.887 287.655 259.605 287.655 242.797C287.655 226.002 262.77 211.043 232.075 209.401C201.38 207.759 176.496 220.055 176.496 236.849Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M177.493 236.901C177.493 253.392 201.933 268.075 232.075 269.69C262.217 271.304 286.657 259.229 286.657 242.738C286.657 226.247 262.217 211.564 232.075 209.949C201.933 208.335 177.493 220.41 177.493 236.901Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M178.504 236.96C178.504 253.162 202.499 267.569 232.088 269.156C261.678 270.743 285.673 258.889 285.673 242.701C285.673 226.5 261.678 212.093 232.088 210.506C202.485 208.919 178.504 220.759 178.504 236.96Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M179.502 237.012C179.502 252.91 203.039 267.041 232.089 268.6C261.126 270.16 284.676 258.526 284.676 242.643C284.676 226.745 261.14 212.614 232.089 211.054C203.039 209.495 179.502 221.115 179.502 237.012Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M180.5 237.071C180.5 252.665 203.591 266.534 232.089 268.052C260.573 269.57 283.678 258.172 283.678 242.578C283.678 226.984 260.586 213.115 232.089 211.597C203.591 210.079 180.5 221.477 180.5 237.071Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M181.497 237.123C181.497 252.413 204.144 266.02 232.075 267.511C260.007 269.001 282.654 257.823 282.654 242.533C282.654 227.242 260.007 213.635 232.075 212.145C204.144 210.655 181.497 221.833 181.497 237.123Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M182.495 237.163C182.495 252.15 204.697 265.48 232.075 266.943C259.454 268.406 281.656 257.449 281.656 242.462C281.656 227.475 259.454 214.144 232.075 212.682C204.697 211.219 182.495 222.19 182.495 237.163Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M183.505 237.219C183.505 251.902 205.263 264.97 232.089 266.406C258.928 267.841 280.672 257.104 280.672 242.421C280.672 227.738 258.915 214.669 232.089 213.234C205.249 211.799 183.505 222.535 183.505 237.219Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M184.504 237.28C184.504 251.66 205.803 264.452 232.09 265.86C258.376 267.267 279.675 256.752 279.675 242.358C279.675 227.965 258.376 215.186 232.09 213.779C205.803 212.371 184.504 222.9 184.504 237.28Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M185.5 237.326C185.5 251.402 206.355 263.932 232.089 265.312C257.823 266.692 278.677 256.383 278.677 242.307C278.677 228.231 257.823 215.701 232.089 214.321C206.355 212.955 185.5 223.25 185.5 237.326Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M186.497 237.383C186.497 251.156 206.906 263.424 232.088 264.762C257.269 266.115 277.678 256.027 277.678 242.255C277.678 228.482 257.269 216.214 232.088 214.875C206.906 213.523 186.497 223.611 186.497 237.383Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M187.496 237.439C187.496 250.908 207.46 262.9 232.075 264.225C256.704 265.536 276.655 255.683 276.655 242.214C276.655 228.745 256.69 216.753 232.075 215.428C207.46 214.103 187.496 223.956 187.496 237.439Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M188.494 237.496C188.494 250.675 208.014 262.391 232.076 263.675C256.152 264.958 275.658 255.326 275.658 242.161C275.658 228.982 256.139 217.265 232.076 215.982C208.014 214.699 188.494 224.317 188.494 237.496Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M189.503 237.546C189.503 250.421 208.564 261.875 232.087 263.131C255.611 264.387 274.672 254.975 274.672 242.1C274.672 229.225 255.611 217.771 232.087 216.515C208.564 215.259 189.503 224.671 189.503 237.546Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M190.501 237.597C190.501 250.169 209.118 261.347 232.088 262.575C255.059 263.804 273.675 254.613 273.675 242.041C273.675 229.469 255.059 218.291 232.088 217.063C209.118 215.835 190.501 225.039 190.501 237.597Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M191.5 237.645C191.5 249.913 209.672 260.829 232.089 262.03C254.507 263.23 272.679 254.26 272.679 241.992C272.679 229.724 254.507 218.808 232.089 217.608C209.672 216.407 191.5 225.391 191.5 237.645Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M192.496 237.713C192.496 249.677 210.223 260.317 232.088 261.49C253.953 262.663 271.68 253.914 271.68 241.949C271.68 229.985 253.953 219.345 232.088 218.172C210.223 216.999 192.496 225.748 192.496 237.713Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M193.494 237.756C193.494 249.417 210.775 259.795 232.074 260.94C253.387 262.086 270.655 253.557 270.655 241.882C270.655 230.221 253.373 219.844 232.074 218.698C210.775 217.567 193.494 226.095 193.494 237.756Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M194.492 237.816C194.492 249.173 211.316 259.288 232.075 260.392C252.835 261.496 269.659 253.189 269.659 241.831C269.659 230.474 252.835 220.359 232.075 219.255C211.329 218.151 194.492 226.458 194.492 237.816Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M195.502 237.871C195.502 248.925 211.881 258.764 232.088 259.855C252.295 260.931 268.673 252.844 268.673 241.79C268.673 230.737 252.295 220.897 232.088 219.807C211.881 218.731 195.502 226.817 195.502 237.871Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M196.5 237.921C196.5 248.672 212.434 258.249 232.089 259.298C251.743 260.346 267.677 252.48 267.677 241.73C267.677 230.98 251.743 221.403 232.089 220.354C212.434 219.291 196.5 227.157 196.5 237.921Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M197.497 237.985C197.497 248.431 212.986 257.733 232.088 258.754C251.189 259.775 266.678 252.13 266.678 241.683C266.678 231.237 251.189 221.935 232.088 220.914C212.986 219.879 197.497 227.524 197.497 237.985Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M198.495 238.022C198.495 248.179 213.525 257.204 232.074 258.198C250.623 259.191 265.654 251.767 265.654 241.61C265.654 231.453 250.623 222.428 232.074 221.434C213.539 220.455 198.495 227.879 198.495 238.022Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M199.493 238.078C199.493 247.931 214.079 256.694 232.075 257.646C250.071 258.612 264.657 251.408 264.657 241.555C264.657 231.702 250.071 222.939 232.075 221.987C214.092 221.035 199.493 228.238 199.493 238.078Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.503 238.126C200.503 247.675 214.644 256.162 232.087 257.101C249.531 258.039 263.672 251.056 263.672 241.507C263.672 231.957 249.531 223.47 232.087 222.532C214.644 221.607 200.503 228.576 200.503 238.126Z",
    fill: "#030511"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M163.623 298.957C163.623 314.054 185.986 327.482 213.567 328.958C241.148 330.435 263.512 319.395 263.512 304.298C263.512 289.201 241.148 275.773 213.567 274.296C185.986 272.82 163.623 283.86 163.623 298.957Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M164.485 299.011C164.485 313.846 186.458 327.039 213.567 328.488C240.676 329.937 262.649 319.09 262.649 304.255C262.649 289.42 240.676 276.227 213.567 274.778C186.458 273.329 164.485 284.176 164.485 299.011Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M165.35 299.059C165.35 313.632 186.932 326.59 213.569 328.026C240.193 329.447 261.788 318.793 261.788 304.221C261.788 289.648 240.206 276.69 213.569 275.254C186.932 273.819 165.35 284.487 165.35 299.059Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M166.225 299.095C166.225 313.406 187.416 326.143 213.568 327.537C239.72 328.931 260.911 318.471 260.911 304.16C260.911 289.849 239.72 277.112 213.568 275.718C187.416 274.324 166.225 284.799 166.225 299.095Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M167.087 299.149C167.087 313.198 187.901 325.701 213.568 327.067C239.234 328.433 260.048 318.166 260.048 304.117C260.048 290.069 239.234 277.566 213.568 276.2C187.901 274.834 167.087 285.101 167.087 299.149Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M167.95 299.192C167.95 312.978 188.373 325.246 213.554 326.585C238.749 327.937 259.158 317.849 259.158 304.063C259.158 290.277 238.736 278.009 213.554 276.67C188.373 275.332 167.95 285.406 167.95 299.192Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M168.828 299.236C168.828 312.76 188.859 324.794 213.569 326.118C238.278 327.443 258.31 317.549 258.31 304.025C258.31 290.501 238.278 278.467 213.569 277.142C188.859 275.817 168.828 285.726 168.828 299.236Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M169.689 299.29C169.689 312.552 189.33 324.351 213.568 325.648C237.805 326.945 257.446 317.244 257.446 303.982C257.446 290.72 237.805 278.921 213.568 277.624C189.33 276.327 169.689 286.028 169.689 299.29Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M170.553 299.336C170.553 312.336 189.803 323.9 213.556 325.17C237.308 326.439 256.558 316.931 256.558 303.932C256.558 290.932 237.308 279.368 213.556 278.098C189.803 276.828 170.553 286.337 170.553 299.336Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M171.428 299.382C171.428 312.12 190.301 323.45 213.568 324.692C236.835 325.934 255.707 316.619 255.707 303.881C255.707 291.144 236.835 279.814 213.568 278.572C190.287 277.33 171.428 286.645 171.428 299.382Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M172.292 299.427C172.292 311.902 190.773 322.997 213.568 324.225C236.364 325.44 254.845 316.318 254.845 303.843C254.845 291.368 236.364 280.272 213.568 279.044C190.773 277.816 172.292 286.952 172.292 299.427Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M173.155 299.467C173.155 311.68 191.245 322.54 213.555 323.741C235.865 324.942 253.956 315.999 253.956 303.786C253.956 291.573 235.865 280.713 213.555 279.512C191.245 278.325 173.155 287.254 173.155 299.467Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M174.029 299.523C174.029 311.474 191.729 322.1 213.567 323.273C235.405 324.446 253.105 315.697 253.105 303.746C253.105 291.795 235.405 281.169 213.567 279.996C191.729 278.823 174.029 287.572 174.029 299.523Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M174.891 299.563C174.891 311.252 192.2 321.657 213.566 322.788C234.919 323.934 252.241 315.378 252.241 303.689C252.241 292.001 234.933 281.596 213.566 280.464C192.2 279.332 174.891 287.874 174.891 299.563Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M175.754 299.609C175.754 311.036 192.686 321.206 213.553 322.324C234.434 323.442 251.352 315.079 251.352 303.653C251.352 292.226 234.421 282.056 213.553 280.938C192.686 279.834 175.754 288.183 175.754 299.609Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M176.632 299.658C176.632 310.822 193.172 320.758 213.568 321.848C233.964 322.938 250.504 314.769 250.504 303.604C250.504 292.44 233.964 282.504 213.568 281.414C193.172 280.324 176.632 288.493 176.632 299.658Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M177.495 299.696C177.495 310.598 193.645 320.299 213.569 321.362C233.493 322.425 249.642 314.448 249.642 303.546C249.642 292.644 233.493 282.943 213.569 281.88C193.645 280.818 177.495 288.794 177.495 299.696Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M178.357 299.736C178.357 310.376 194.115 319.843 213.554 320.878C232.993 321.913 248.751 314.13 248.751 303.504C248.751 292.878 232.993 283.397 213.554 282.362C194.115 281.327 178.357 289.096 178.357 299.736Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M179.233 299.796C179.233 310.174 194.601 319.406 213.568 320.427C232.535 321.448 247.902 313.845 247.902 303.481C247.902 293.103 232.535 283.871 213.568 282.85C194.601 281.829 179.233 289.419 179.233 299.796Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M180.098 299.842C180.098 309.958 195.088 318.955 213.569 319.949C232.051 320.943 247.041 313.546 247.041 303.43C247.041 293.315 232.051 284.317 213.569 283.324C195.088 282.33 180.098 289.727 180.098 299.842Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M180.961 299.895C180.961 309.748 195.56 318.511 213.556 319.477C231.553 320.443 246.152 313.239 246.152 303.386C246.152 293.533 231.553 284.77 213.556 283.804C195.56 282.824 180.961 290.042 180.961 299.895Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M181.835 299.939C181.835 309.53 196.043 318.058 213.568 318.996C231.092 319.935 245.301 312.924 245.301 303.333C245.301 293.742 231.092 285.214 213.568 284.276C196.043 283.337 181.835 290.348 181.835 299.939Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M182.697 299.981C182.697 309.31 196.515 317.617 213.567 318.528C230.62 319.439 244.437 312.622 244.437 303.293C244.437 293.964 230.62 285.656 213.567 284.746C196.515 283.835 182.697 290.652 182.697 299.981Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M183.561 300.033C183.561 309.1 196.987 317.173 213.554 318.056C230.122 318.939 243.548 312.315 243.548 303.249C243.548 294.182 230.122 286.109 213.554 285.226C197 284.329 183.561 290.967 183.561 300.033Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M184.438 300.071C184.438 308.876 197.487 316.714 213.569 317.57C229.651 318.425 242.7 311.995 242.7 303.19C242.7 294.386 229.651 286.547 213.569 285.692C197.473 284.822 184.438 291.267 184.438 300.071Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M185.299 300.119C185.299 308.661 197.957 316.265 213.567 317.093C229.177 317.921 241.835 311.684 241.835 303.142C241.835 294.599 229.177 286.996 213.567 286.168C197.957 285.34 185.299 291.577 185.299 300.119Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 300.172C186.163 308.452 198.43 315.821 213.555 316.635C228.68 317.449 240.947 311.391 240.947 303.111C240.947 294.831 228.68 287.462 213.555 286.648C198.43 285.833 186.163 291.892 186.163 300.172Z",
    fill: "#030511"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M65.5249 222.078C65.5249 237.175 87.8888 250.603 115.47 252.079C143.05 253.556 165.414 242.516 165.414 227.419C165.414 212.322 143.05 198.894 115.47 197.418C87.8888 195.941 65.5249 206.981 65.5249 222.078Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M66.3867 222.124C66.3867 236.959 88.3597 250.152 115.469 251.601C142.578 253.05 164.551 242.203 164.551 227.368C164.551 212.533 142.578 199.341 115.469 197.892C88.3597 196.443 66.3867 207.289 66.3867 222.124Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M67.2642 222.173C67.2642 236.745 88.8462 249.704 115.483 251.139C142.107 252.56 163.703 241.907 163.703 227.334C163.703 212.761 142.121 199.803 115.483 198.368C88.8462 196.932 67.2642 207.614 67.2642 222.173Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M68.1255 222.217C68.1255 236.527 89.3166 249.265 115.469 250.658C141.62 252.052 162.812 241.592 162.812 227.281C162.812 212.971 141.62 200.233 115.469 198.839C89.3166 197.446 68.1255 207.906 68.1255 222.217Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M68.9897 222.263C68.9897 236.311 89.8034 248.814 115.47 250.18C141.137 251.546 161.95 241.279 161.95 227.231C161.95 213.182 141.137 200.68 115.47 199.313C89.8034 197.947 68.9897 208.214 68.9897 222.263Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M69.8647 222.305C69.8647 236.091 90.2875 248.359 115.469 249.698C140.664 251.05 161.073 240.962 161.073 227.176C161.073 213.39 140.65 201.122 115.469 199.783C90.274 198.445 69.8647 208.532 69.8647 222.305Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M70.7271 222.361C70.7271 235.885 90.7589 247.919 115.468 249.244C140.178 250.568 160.21 240.674 160.21 227.15C160.21 213.626 140.178 201.592 115.468 200.267C90.7589 198.943 70.7271 208.837 70.7271 222.361Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M71.5903 222.403C71.5903 235.665 91.2312 247.464 115.469 248.761C139.707 250.059 159.347 240.357 159.347 227.095C159.347 213.834 139.707 202.035 115.469 200.737C91.2447 199.44 71.5903 209.142 71.5903 222.403Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M72.4678 222.453C72.4678 235.453 91.7177 247.017 115.47 248.287C139.223 249.557 158.472 240.048 158.472 227.049C158.472 214.049 139.223 202.485 115.47 201.215C91.7177 199.946 72.4678 209.454 72.4678 222.453Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M73.3296 222.496C73.3296 235.233 92.2021 246.563 115.469 247.805C138.75 249.047 157.609 239.732 157.609 226.995C157.609 214.257 138.736 202.927 115.469 201.685C92.2021 200.443 73.3296 209.758 73.3296 222.496Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M74.1929 222.546C74.1929 235.021 92.6744 246.116 115.47 247.344C138.265 248.559 156.747 239.437 156.747 226.962C156.747 214.487 138.265 203.391 115.47 202.163C92.6744 200.949 74.1929 210.071 74.1929 222.546Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M75.0693 222.586C75.0693 234.799 93.16 245.66 115.47 246.86C137.78 248.061 155.871 239.119 155.871 226.906C155.871 214.693 137.78 203.832 115.47 202.631C93.16 201.431 75.0693 210.373 75.0693 222.586Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M75.9316 222.636C75.9316 234.587 93.6314 245.213 115.47 246.386C137.308 247.559 155.007 238.81 155.007 226.859C155.007 214.908 137.308 204.282 115.47 203.109C93.6314 201.936 75.9316 210.686 75.9316 222.636Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M76.7944 222.676C76.7944 234.365 94.1032 244.77 115.47 245.902C136.836 247.033 154.145 238.491 154.145 226.803C154.145 215.114 136.836 204.709 115.47 203.577C94.1167 202.446 76.7944 210.988 76.7944 222.676Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M77.6689 222.729C77.6689 234.155 94.6003 244.326 115.468 245.443C136.335 246.561 153.267 238.198 153.267 226.772C153.267 215.346 136.335 205.175 115.468 204.057C94.6003 202.939 77.6689 211.302 77.6689 222.729Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M78.5332 222.771C78.5332 233.935 95.0736 243.871 115.469 244.961C135.865 246.051 152.406 237.882 152.406 226.718C152.406 215.553 135.865 205.617 115.469 204.527C95.0736 203.437 78.5332 211.607 78.5332 222.771Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M79.395 222.819C79.395 233.721 95.5445 243.422 115.468 244.485C135.392 245.547 151.542 237.571 151.542 226.669C151.542 215.767 135.392 206.065 115.468 205.003C95.5445 203.954 79.395 211.93 79.395 222.819Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M80.2715 222.867C80.2715 233.507 96.03 242.974 115.469 244.009C134.907 245.044 150.666 237.261 150.666 226.635C150.666 215.995 134.907 206.528 115.469 205.493C96.03 204.444 80.2715 212.228 80.2715 222.867Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M81.1348 222.91C81.1348 233.287 96.5024 242.519 115.469 243.541C134.436 244.548 149.804 236.958 149.804 226.594C149.804 216.217 134.436 206.984 115.469 205.963C96.5024 204.942 81.1348 212.532 81.1348 222.91Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M81.9971 222.964C81.9971 233.079 96.9872 242.077 115.469 243.07C133.95 244.064 148.941 236.667 148.941 226.552C148.941 216.436 133.95 207.439 115.469 206.445C96.9872 205.451 81.9971 212.848 81.9971 222.964Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M82.8755 223.006C82.8755 232.859 97.4747 241.622 115.471 242.588C133.481 243.554 148.067 236.35 148.067 226.497C148.067 216.644 133.467 207.881 115.471 206.915C97.4747 205.949 82.8755 213.153 82.8755 223.006Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M83.7373 223.052C83.7373 232.643 97.9456 241.171 115.47 242.11C132.995 243.048 147.203 236.038 147.203 226.447C147.203 216.856 132.995 208.327 115.47 207.389C97.9456 206.451 83.7373 213.461 83.7373 223.052Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M84.6006 223.104C84.6006 232.433 98.418 240.741 115.471 241.651C132.523 242.562 146.341 235.745 146.341 226.416C146.341 217.087 132.523 208.78 115.471 207.869C98.4314 206.944 84.6006 213.775 84.6006 223.104Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M85.4751 223.144C85.4751 232.211 98.9015 240.284 115.469 241.167C132.036 242.05 145.463 235.426 145.463 226.36C145.463 217.293 132.036 209.22 115.469 208.337C98.9015 207.454 85.4751 214.078 85.4751 223.144Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M86.3379 223.19C86.3379 231.995 99.3869 239.833 115.469 240.689C131.551 241.544 144.6 235.114 144.6 226.309C144.6 217.505 131.551 209.666 115.469 208.811C99.3869 207.955 86.3379 214.386 86.3379 223.19Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M87.2002 223.243C87.2002 231.785 99.8583 239.389 115.469 240.217C131.079 241.045 143.737 234.807 143.737 226.265C143.737 217.723 131.079 210.119 115.469 209.291C99.8583 208.449 87.2002 214.7 87.2002 223.243Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0776 223.285C88.0776 231.565 100.345 238.934 115.47 239.748C130.595 240.562 142.862 234.504 142.862 226.224C142.862 217.944 130.595 210.575 115.47 209.761C100.345 208.947 88.0776 215.005 88.0776 223.285Z",
    fill: "#030511"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.326 136.312L301.596 207.258L228.316 250.853L228.033 179.907L301.326 136.312Z",
    fill: "url(#paint0_linear_1136_96404)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.033 179.907L228.316 250.853L154.552 207.258L154.269 136.312L228.033 179.907Z",
    fill: "url(#paint1_linear_1136_96404)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.326 136.321L228.033 179.915L154.269 136.321L227.561 92.7266L301.326 136.321Z",
    fill: "url(#paint2_linear_1136_96404)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.033 179.569L154.565 136.141L154.269 136.32L228.033 179.914L301.326 136.32L301.029 136.141L228.033 179.569Z",
    fill: "url(#paint3_linear_1136_96404)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.392 186.271L213.568 230.265L167.815 203.231L167.64 159.223L213.392 186.271Z",
    fill: "url(#paint4_linear_1136_96404)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.863 198.262L213.527 219.859V230.264L167.815 203.23L175.863 198.262Z",
    fill: "#7582D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.971 180.491L213.231 202.543V187.363L175.971 165.297V180.491Z",
    fill: "url(#paint5_linear_1136_96404)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.25 179.506L190.584 186.792V175.669L178.25 168.383V179.506Z",
    fill: "url(#paint6_linear_1136_96404)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.164 169.514V178.843L178.25 179.506V168.383L180.164 169.514Z",
    fill: "#232D6C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M180.164 178.848L190.584 184.809V186.796L178.25 179.51L180.164 178.848Z",
    fill: "#425CFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M183.71 178.986L182.685 178.378V177.164L183.71 177.757V178.986Z",
    fill: "url(#paint7_linear_1136_96404)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 180.009L184.411 179.402V178.188L185.435 178.781V180.009Z",
    fill: "url(#paint8_linear_1136_96404)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 181.033L186.122 180.425V179.211L187.146 179.804V181.033Z",
    fill: "url(#paint9_linear_1136_96404)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.71 176.65L182.685 176.043V174.828L183.71 175.422V176.65Z",
    fill: "url(#paint10_linear_1136_96404)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 177.673L184.411 177.066V175.852L185.435 176.445V177.673Z",
    fill: "url(#paint11_linear_1136_96404)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 178.693L186.122 178.086V176.871L187.146 177.465V178.693Z",
    fill: "url(#paint12_linear_1136_96404)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183.71 174.322L182.685 173.728V172.5L183.71 173.093V174.322Z",
    fill: "url(#paint13_linear_1136_96404)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 175.345L184.411 174.752V173.523L185.435 174.117V175.345Z",
    fill: "url(#paint14_linear_1136_96404)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 176.365L186.122 175.757V174.543L187.146 175.136V176.365Z",
    fill: "url(#paint15_linear_1136_96404)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M205.48 186.505L201.584 184.145C201.409 184.035 201.26 183.8 201.26 183.621C201.26 183.441 201.409 183.372 201.584 183.483L205.48 185.843C205.655 185.953 205.803 186.188 205.803 186.367C205.803 186.546 205.655 186.615 205.48 186.505Z",
    fill: "url(#paint16_linear_1136_96404)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.872 189.778L206.976 187.419C206.801 187.308 206.653 187.074 206.653 186.894C206.653 186.715 206.801 186.646 206.976 186.756L210.872 189.116C211.047 189.226 211.196 189.461 211.196 189.64C211.196 189.82 211.047 189.875 210.872 189.778Z",
    fill: "url(#paint17_linear_1136_96404)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175.972 196.416L213.231 218.469V203.289L175.972 181.223V196.416Z",
    fill: "url(#paint18_linear_1136_96404)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M178.249 195.435L190.583 202.722V191.599L178.249 184.312V195.435Z",
    fill: "url(#paint19_linear_1136_96404)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M180.163 185.444V194.773L178.249 195.435V184.312L180.163 185.444Z",
    fill: "#232D6C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.163 194.773L190.583 200.735V202.722L178.249 195.436L180.163 194.773Z",
    fill: "#425CFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 194.911L182.684 194.304V193.09L183.708 193.683V194.911Z",
    fill: "url(#paint20_linear_1136_96404)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 195.931L184.411 195.324V194.109L185.435 194.703V195.931Z",
    fill: "url(#paint21_linear_1136_96404)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.147 196.95L186.122 196.343V195.129L187.147 195.722V196.95Z",
    fill: "url(#paint22_linear_1136_96404)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 192.575L182.684 191.982V190.754L183.708 191.347V192.575Z",
    fill: "url(#paint23_linear_1136_96404)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 193.599L184.411 193.006V191.777L185.435 192.371V193.599Z",
    fill: "url(#paint24_linear_1136_96404)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.147 194.618L186.122 194.025V192.797L187.147 193.39V194.618Z",
    fill: "url(#paint25_linear_1136_96404)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 190.247L182.684 189.654V188.426L183.708 189.033V190.247Z",
    fill: "url(#paint26_linear_1136_96404)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 191.267L184.411 190.673V189.445L185.435 190.052V191.267Z",
    fill: "url(#paint27_linear_1136_96404)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M187.147 192.286L186.122 191.693V190.465L187.147 191.072V192.286Z",
    fill: "url(#paint28_linear_1136_96404)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M205.481 202.427L201.585 200.067C201.41 199.957 201.262 199.722 201.262 199.543C201.262 199.363 201.41 199.294 201.585 199.405L205.481 201.765C205.656 201.875 205.805 202.11 205.805 202.289C205.805 202.468 205.656 202.537 205.481 202.427Z",
    fill: "url(#paint29_linear_1136_96404)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M210.872 205.704L206.976 203.344C206.801 203.234 206.652 202.999 206.652 202.82C206.652 202.641 206.801 202.572 206.976 202.682L210.872 205.042C211.047 205.152 211.195 205.387 211.195 205.566C211.195 205.746 211.047 205.815 210.872 205.704Z",
    fill: "url(#paint30_linear_1136_96404)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.204 153.168L295.042 211.652L242.752 242.758L242.914 184.273L295.204 153.168Z",
    fill: "url(#paint31_linear_1136_96404)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M242.914 184.276L242.752 242.76L237.481 239.738L237.643 181.254L242.914 184.276Z",
    fill: "url(#paint32_linear_1136_96404)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M295.204 153.171L242.914 184.276L237.643 181.254L289.933 150.148L295.204 153.171Z",
    fill: "url(#paint33_linear_1136_96404)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M242.914 184.024L237.859 181.126L237.643 181.25L242.914 184.272L295.204 153.167L295.002 153.043L242.914 184.024Z",
    fill: "url(#paint34_linear_1136_96404)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M287.399 169.602L287.291 204.474L250.557 226.32L250.678 191.447L287.399 169.602Z",
    fill: "url(#paint35_linear_1136_96404)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M283.759 171.768V202.128L287.291 204.474V169.602L283.759 171.768Z",
    fill: "#3C4682"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M283.759 202.129L250.557 221.449V226.32L287.291 204.475L283.759 202.129Z",
    fill: "#5F6CBF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.26 186.311L275.389 181.605C275.645 181.453 275.861 181.108 275.861 180.832C275.861 180.556 275.658 180.46 275.402 180.598L267.274 185.303C267.018 185.455 266.802 185.8 266.802 186.076C266.788 186.352 267.004 186.463 267.26 186.311Z",
    fill: "url(#paint36_linear_1136_96404)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M267.571 188.513L272.599 185.601C272.855 185.449 273.071 185.104 273.071 184.828C273.071 184.552 272.869 184.456 272.613 184.594L267.585 187.505C267.328 187.657 267.113 188.002 267.113 188.278C267.113 188.568 267.315 188.665 267.571 188.513Z",
    fill: "url(#paint37_linear_1136_96404)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M260.532 192.603L265.56 189.691C265.816 189.539 266.032 189.194 266.032 188.918C266.032 188.642 265.829 188.545 265.573 188.683L260.545 191.595C260.289 191.747 260.073 192.092 260.073 192.368C260.073 192.644 260.275 192.754 260.532 192.603Z",
    fill: "url(#paint38_linear_1136_96404)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M264.064 192.942L271.128 188.843C271.384 188.691 271.6 188.346 271.6 188.07C271.6 187.794 271.398 187.698 271.141 187.836L264.078 191.934C263.822 192.086 263.606 192.431 263.606 192.707C263.606 192.997 263.808 193.094 264.064 192.942Z",
    fill: "url(#paint39_linear_1136_96404)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M254.238 198.641L261.301 194.542C261.557 194.391 261.773 194.046 261.773 193.77C261.773 193.494 261.571 193.397 261.315 193.535L254.251 197.634C253.995 197.785 253.779 198.13 253.779 198.406C253.779 198.696 253.982 198.793 254.238 198.641Z",
    fill: "url(#paint40_linear_1136_96404)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M266.181 194.12L272.153 190.656C272.409 190.504 272.625 190.159 272.625 189.883C272.625 189.607 272.423 189.51 272.167 189.648L266.195 193.112C265.939 193.264 265.723 193.609 265.723 193.885C265.723 194.175 265.925 194.271 266.181 194.12Z",
    fill: "url(#paint41_linear_1136_96404)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M258.766 198.416L264.738 194.953C264.994 194.801 265.21 194.456 265.21 194.18C265.21 193.904 265.008 193.807 264.752 193.945L258.78 197.409C258.524 197.561 258.308 197.906 258.308 198.182C258.308 198.458 258.51 198.568 258.766 198.416Z",
    fill: "url(#paint42_linear_1136_96404)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M269.119 194.806L275.212 191.273C275.468 191.121 275.684 190.776 275.684 190.5C275.684 190.224 275.482 190.127 275.226 190.265L269.132 193.798C268.876 193.95 268.661 194.295 268.661 194.571C268.661 194.861 268.863 194.957 269.119 194.806Z",
    fill: "url(#paint43_linear_1136_96404)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M261.153 199.431L267.246 195.898C267.502 195.746 267.718 195.401 267.718 195.125C267.718 194.849 267.516 194.752 267.26 194.89L261.167 198.423C260.911 198.575 260.695 198.92 260.695 199.196C260.695 199.472 260.897 199.582 261.153 199.431Z",
    fill: "url(#paint44_linear_1136_96404)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M256.233 202.285L259.279 200.519C259.535 200.367 259.751 200.022 259.751 199.746C259.751 199.47 259.549 199.374 259.293 199.512L256.246 201.278C255.99 201.43 255.774 201.775 255.774 202.051C255.774 202.327 255.977 202.437 256.233 202.285Z",
    fill: "url(#paint45_linear_1136_96404)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M266.329 198.821L272.678 195.136C272.934 194.984 273.15 194.639 273.15 194.363C273.15 194.087 272.948 193.991 272.692 194.129L266.342 197.813C266.086 197.965 265.871 198.31 265.871 198.586C265.871 198.876 266.073 198.973 266.329 198.821Z",
    fill: "url(#paint46_linear_1136_96404)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M258.12 203.59L264.469 199.906C264.725 199.754 264.941 199.409 264.941 199.133C264.941 198.857 264.738 198.76 264.482 198.898L258.133 202.583C257.877 202.735 257.661 203.08 257.661 203.356C257.648 203.632 257.85 203.742 258.12 203.59Z",
    fill: "url(#paint47_linear_1136_96404)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M267.663 200.445L272.705 197.519C272.961 197.367 273.177 197.022 273.177 196.746C273.177 196.47 272.975 196.374 272.719 196.512L267.677 199.437C267.421 199.589 267.205 199.934 267.205 200.21C267.205 200.486 267.407 200.596 267.663 200.445Z",
    fill: "url(#paint48_linear_1136_96404)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M268.903 204.335L273.945 201.41C274.201 201.258 274.417 200.913 274.417 200.637C274.417 200.361 274.214 200.264 273.958 200.402L268.917 203.328C268.661 203.48 268.445 203.825 268.445 204.101C268.445 204.377 268.647 204.487 268.903 204.335Z",
    fill: "url(#paint49_linear_1136_96404)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M261.909 208.441L266.95 205.515C267.206 205.363 267.422 205.018 267.422 204.742C267.422 204.466 267.22 204.37 266.964 204.508L261.922 207.433C261.666 207.585 261.45 207.93 261.45 208.206C261.45 208.496 261.652 208.592 261.909 208.441Z",
    fill: "url(#paint50_linear_1136_96404)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M270.171 206.566L275.212 203.64C275.469 203.488 275.684 203.143 275.684 202.867C275.684 202.591 275.482 202.495 275.226 202.633L270.184 205.558C269.928 205.71 269.712 206.055 269.712 206.331C269.712 206.607 269.915 206.717 270.171 206.566Z",
    fill: "url(#paint51_linear_1136_96404)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M260.008 212.593L265.05 209.667C265.306 209.516 265.522 209.171 265.522 208.895C265.522 208.619 265.319 208.522 265.063 208.66L260.022 211.586C259.765 211.737 259.55 212.082 259.55 212.358C259.55 212.648 259.752 212.745 260.008 212.593Z",
    fill: "url(#paint52_linear_1136_96404)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M260.911 204.37L265.953 201.445C266.209 201.293 266.424 200.948 266.424 200.672C266.424 200.396 266.222 200.299 265.966 200.437L260.924 203.363C260.668 203.515 260.453 203.86 260.453 204.136C260.453 204.412 260.655 204.522 260.911 204.37Z",
    fill: "url(#paint53_linear_1136_96404)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M266.963 203.248L275.092 198.542C275.348 198.391 275.564 198.046 275.564 197.77C275.564 197.494 275.361 197.397 275.105 197.535L266.977 202.241C266.721 202.393 266.505 202.738 266.505 203.014C266.505 203.303 266.707 203.4 266.963 203.248Z",
    fill: "url(#paint54_linear_1136_96404)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M257.619 191.899L265.357 187.414C265.613 187.262 265.829 186.917 265.829 186.641C265.829 186.365 265.627 186.268 265.371 186.406L257.633 190.891C257.377 191.043 257.161 191.388 257.161 191.664C257.161 191.94 257.363 192.037 257.619 191.899Z",
    fill: "url(#paint55_linear_1136_96404)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M244.748 187.43C244.748 187.402 244.748 187.375 244.748 187.347C244.748 187.32 244.748 187.292 244.748 187.264C244.748 187.237 244.748 187.209 244.762 187.182C244.762 187.154 244.775 187.126 244.775 187.099C244.775 187.071 244.788 187.044 244.788 187.016C244.788 186.988 244.802 186.961 244.802 186.933C244.802 186.906 244.815 186.878 244.815 186.85C244.829 186.823 244.829 186.795 244.842 186.768C244.842 186.74 244.856 186.726 244.869 186.699V186.685C244.883 186.657 244.883 186.63 244.896 186.602C244.91 186.574 244.91 186.547 244.923 186.519C244.937 186.492 244.937 186.464 244.95 186.436C244.964 186.409 244.977 186.381 244.977 186.354C244.991 186.326 245.004 186.298 245.004 186.271C245.018 186.243 245.031 186.216 245.045 186.188C245.058 186.16 245.072 186.133 245.085 186.105C245.099 186.078 245.112 186.036 245.139 186.009C245.152 185.967 245.179 185.94 245.193 185.898C245.193 185.898 245.193 185.898 245.193 185.884C245.193 185.871 245.206 185.871 245.206 185.857C245.247 185.788 245.287 185.733 245.328 185.664C245.355 185.608 245.395 185.567 245.436 185.512C245.463 185.484 245.476 185.443 245.503 185.415C245.516 185.388 245.543 185.36 245.57 185.332C245.597 185.305 245.611 185.277 245.638 185.263C245.665 185.236 245.678 185.222 245.705 185.194L245.719 185.181C245.732 185.167 245.759 185.139 245.773 185.125C245.8 185.098 245.813 185.084 245.84 185.056C245.867 185.029 245.88 185.015 245.907 184.987C245.934 184.96 245.948 184.946 245.975 184.918C246.002 184.905 246.015 184.877 246.042 184.863C246.069 184.849 246.083 184.822 246.11 184.808C246.137 184.794 246.15 184.78 246.177 184.753C246.204 184.739 246.217 184.725 246.244 184.711C246.271 184.698 246.285 184.684 246.312 184.67C246.312 184.67 246.325 184.67 246.325 184.656C246.339 184.642 246.352 184.642 246.379 184.629C246.406 184.615 246.42 184.601 246.447 184.601C246.474 184.587 246.487 184.573 246.514 184.573C246.541 184.56 246.554 184.56 246.581 184.546C246.608 184.532 246.622 184.532 246.649 184.518C246.676 184.504 246.689 184.504 246.716 184.491C246.743 184.491 246.757 184.477 246.784 184.477C246.811 184.477 246.824 184.463 246.851 184.463C246.878 184.463 246.891 184.449 246.918 184.449C246.932 184.449 246.959 184.449 246.972 184.449H246.986C247.013 184.449 247.04 184.449 247.067 184.449C247.094 184.449 247.121 184.449 247.148 184.449C247.175 184.449 247.215 184.463 247.242 184.463C247.282 184.477 247.323 184.477 247.35 184.491C247.39 184.504 247.444 184.532 247.485 184.546L248.846 185.36C248.698 185.277 248.536 185.236 248.334 185.25C248.145 185.263 247.929 185.332 247.714 185.47C247.498 185.595 247.282 185.774 247.094 185.981C246.905 186.188 246.73 186.423 246.595 186.671C246.595 186.671 246.595 186.671 246.595 186.685C246.447 186.933 246.339 187.209 246.258 187.471C246.177 187.747 246.137 188.01 246.137 188.272C246.137 188.52 246.177 188.741 246.258 188.92C246.339 189.1 246.46 189.224 246.595 189.307L245.233 188.493C245.126 188.424 245.031 188.341 244.95 188.217C244.923 188.175 244.91 188.148 244.896 188.106C244.883 188.079 244.869 188.051 244.856 188.023C244.842 187.996 244.842 187.968 244.829 187.941C244.815 187.913 244.815 187.885 244.802 187.858C244.802 187.83 244.788 187.803 244.788 187.775C244.788 187.747 244.775 187.72 244.775 187.692C244.775 187.665 244.775 187.637 244.762 187.609C244.762 187.582 244.762 187.554 244.762 187.527C244.762 187.499 244.762 187.471 244.762 187.444C244.748 187.471 244.748 187.444 244.748 187.43Z",
    fill: "#9097C4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M247.699 185.504C246.823 186.014 246.109 187.284 246.122 188.319C246.122 189.354 246.837 189.768 247.713 189.244C248.589 188.719 249.304 187.463 249.29 186.428C249.29 185.407 248.562 184.993 247.699 185.504Z",
    fill: "url(#paint56_linear_1136_96404)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M290.675 160.66C290.675 160.633 290.675 160.605 290.675 160.578C290.675 160.55 290.675 160.522 290.675 160.495C290.675 160.467 290.675 160.44 290.689 160.412C290.689 160.384 290.702 160.357 290.702 160.329C290.702 160.302 290.716 160.274 290.716 160.246C290.716 160.219 290.729 160.191 290.729 160.164C290.729 160.136 290.743 160.108 290.743 160.081C290.756 160.053 290.756 160.026 290.77 159.998C290.77 159.97 290.783 159.957 290.797 159.929V159.915C290.81 159.888 290.81 159.86 290.824 159.832C290.837 159.805 290.837 159.777 290.851 159.75C290.864 159.722 290.864 159.694 290.877 159.667C290.891 159.639 290.904 159.612 290.904 159.584C290.918 159.556 290.931 159.529 290.931 159.501C290.945 159.474 290.958 159.446 290.972 159.418C290.985 159.391 290.999 159.363 291.012 159.336C291.026 159.308 291.039 159.267 291.066 159.239C291.08 159.198 291.107 159.17 291.12 159.129C291.12 159.129 291.12 159.129 291.12 159.115C291.12 159.101 291.134 159.101 291.134 159.087C291.174 159.018 291.215 158.963 291.255 158.894C291.282 158.839 291.322 158.797 291.363 158.742C291.39 158.715 291.403 158.673 291.43 158.646C291.444 158.618 291.471 158.59 291.498 158.563C291.525 158.535 291.538 158.508 291.565 158.494C291.592 158.466 291.605 158.452 291.632 158.425L291.646 158.411C291.659 158.397 291.686 158.37 291.7 158.356C291.727 158.328 291.74 158.314 291.767 158.287C291.794 158.259 291.808 158.245 291.835 158.218C291.862 158.19 291.875 158.176 291.902 158.149C291.929 158.135 291.942 158.107 291.969 158.094C291.996 158.08 292.01 158.052 292.037 158.038C292.064 158.025 292.077 158.011 292.104 157.983C292.131 157.969 292.145 157.956 292.172 157.942C292.199 157.928 292.212 157.914 292.239 157.9C292.239 157.9 292.253 157.9 292.253 157.887C292.266 157.873 292.279 157.873 292.306 157.859C292.333 157.845 292.347 157.831 292.374 157.831C292.401 157.818 292.414 157.804 292.441 157.804C292.468 157.79 292.482 157.79 292.509 157.776C292.536 157.762 292.549 157.762 292.576 157.749C292.603 157.735 292.616 157.735 292.643 157.721C292.67 157.721 292.684 157.707 292.711 157.707C292.738 157.707 292.751 157.693 292.778 157.693C292.805 157.693 292.819 157.68 292.846 157.68C292.859 157.68 292.886 157.68 292.9 157.68H292.913C292.94 157.68 292.967 157.68 292.994 157.68C293.021 157.68 293.048 157.68 293.075 157.68C293.102 157.68 293.142 157.693 293.169 157.693C293.21 157.707 293.25 157.707 293.277 157.721C293.317 157.735 293.371 157.762 293.412 157.776L294.773 158.59C294.625 158.508 294.463 158.466 294.261 158.48C294.072 158.494 293.857 158.563 293.641 158.701C293.425 158.825 293.21 159.004 293.021 159.211C292.832 159.418 292.657 159.653 292.522 159.901C292.522 159.901 292.522 159.901 292.522 159.915C292.374 160.164 292.266 160.44 292.185 160.702C292.104 160.978 292.064 161.24 292.064 161.502C292.064 161.751 292.104 161.971 292.185 162.151C292.266 162.33 292.387 162.454 292.522 162.537L291.161 161.723C291.053 161.654 290.958 161.571 290.877 161.447C290.851 161.406 290.837 161.378 290.824 161.337C290.81 161.309 290.797 161.281 290.783 161.254C290.77 161.226 290.77 161.199 290.756 161.171C290.743 161.143 290.743 161.116 290.729 161.088C290.729 161.061 290.716 161.033 290.716 161.005C290.716 160.978 290.702 160.95 290.702 160.923C290.702 160.895 290.702 160.867 290.689 160.84C290.689 160.812 290.689 160.785 290.689 160.757C290.689 160.729 290.689 160.702 290.689 160.674C290.675 160.716 290.675 160.688 290.675 160.66Z",
    fill: "#9097C4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M293.615 158.743C292.739 159.253 292.025 160.523 292.038 161.558C292.038 162.593 292.753 163.007 293.629 162.483C294.505 161.972 295.22 160.702 295.206 159.667C295.206 158.632 294.492 158.218 293.615 158.743Z",
    fill: "url(#paint57_linear_1136_96404)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M244.748 235.02C244.748 234.992 244.748 234.965 244.748 234.937C244.748 234.909 244.748 234.882 244.748 234.854C244.748 234.827 244.748 234.799 244.762 234.771C244.762 234.744 244.775 234.716 244.775 234.689C244.775 234.661 244.788 234.633 244.788 234.606C244.788 234.578 244.802 234.551 244.802 234.523C244.802 234.495 244.815 234.468 244.815 234.44C244.829 234.413 244.829 234.385 244.842 234.357C244.842 234.33 244.856 234.316 244.869 234.288V234.275C244.883 234.247 244.883 234.219 244.896 234.192C244.91 234.164 244.91 234.137 244.923 234.109C244.937 234.081 244.937 234.054 244.95 234.026C244.964 233.999 244.977 233.971 244.977 233.943C244.991 233.916 245.004 233.888 245.004 233.861C245.018 233.833 245.031 233.805 245.045 233.778C245.058 233.75 245.072 233.723 245.085 233.695C245.099 233.667 245.112 233.626 245.139 233.598C245.152 233.557 245.179 233.529 245.193 233.488C245.193 233.488 245.193 233.488 245.193 233.474C245.193 233.46 245.206 233.46 245.206 233.447C245.247 233.378 245.287 233.322 245.328 233.253C245.355 233.198 245.395 233.157 245.436 233.102C245.463 233.074 245.476 233.033 245.503 233.005C245.516 232.977 245.543 232.95 245.57 232.922C245.597 232.895 245.611 232.867 245.638 232.853C245.665 232.826 245.678 232.812 245.705 232.784L245.719 232.77C245.732 232.757 245.759 232.729 245.773 232.715C245.8 232.688 245.813 232.674 245.84 232.646C245.867 232.619 245.88 232.605 245.907 232.577C245.934 232.55 245.948 232.536 245.975 232.508C246.002 232.494 246.015 232.467 246.042 232.453C246.069 232.439 246.083 232.412 246.11 232.398C246.137 232.384 246.15 232.37 246.177 232.343C246.204 232.329 246.217 232.315 246.244 232.301C246.271 232.287 246.285 232.274 246.312 232.26C246.312 232.26 246.325 232.26 246.325 232.246C246.339 232.232 246.352 232.232 246.379 232.218C246.406 232.205 246.42 232.191 246.447 232.191C246.474 232.177 246.487 232.163 246.514 232.163C246.541 232.149 246.554 232.149 246.581 232.136C246.608 232.122 246.622 232.122 246.649 232.108C246.676 232.094 246.689 232.094 246.716 232.08C246.743 232.08 246.757 232.067 246.784 232.067C246.811 232.067 246.824 232.053 246.851 232.053C246.878 232.053 246.891 232.039 246.918 232.039C246.932 232.039 246.959 232.039 246.972 232.039H246.986C247.013 232.039 247.04 232.039 247.067 232.039C247.094 232.039 247.121 232.039 247.148 232.039C247.175 232.039 247.215 232.053 247.242 232.053C247.282 232.067 247.323 232.067 247.35 232.08C247.39 232.094 247.444 232.122 247.485 232.136L248.846 232.95C248.698 232.867 248.536 232.826 248.334 232.839C248.145 232.853 247.929 232.922 247.714 233.06C247.498 233.184 247.282 233.364 247.094 233.571C246.905 233.778 246.73 234.012 246.595 234.261C246.595 234.261 246.595 234.261 246.595 234.275C246.447 234.523 246.339 234.799 246.258 235.061C246.177 235.337 246.137 235.599 246.137 235.862C246.137 236.11 246.177 236.331 246.258 236.51C246.339 236.69 246.46 236.814 246.595 236.897L245.233 236.082C245.126 236.013 245.031 235.931 244.95 235.806C244.923 235.765 244.91 235.737 244.896 235.696C244.883 235.668 244.869 235.641 244.856 235.613C244.842 235.586 244.842 235.558 244.829 235.53C244.815 235.503 244.815 235.475 244.802 235.448C244.802 235.42 244.788 235.392 244.788 235.365C244.788 235.337 244.775 235.31 244.775 235.282C244.775 235.254 244.775 235.227 244.762 235.199C244.762 235.172 244.762 235.144 244.762 235.116C244.762 235.089 244.762 235.061 244.762 235.034C244.748 235.061 244.748 235.047 244.748 235.02Z",
    fill: "#9097C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M247.699 233.094C246.823 233.604 246.109 234.874 246.122 235.909C246.122 236.944 246.837 237.358 247.713 236.833C248.589 236.309 249.304 235.053 249.29 234.018C249.29 232.997 248.562 232.583 247.699 233.094Z",
    fill: "url(#paint58_linear_1136_96404)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M290.675 208.25C290.675 208.223 290.675 208.195 290.675 208.168C290.675 208.14 290.675 208.112 290.675 208.085C290.675 208.057 290.675 208.03 290.689 208.002C290.689 207.974 290.702 207.947 290.702 207.919C290.702 207.892 290.716 207.864 290.716 207.836C290.716 207.809 290.729 207.781 290.729 207.754C290.729 207.726 290.743 207.698 290.743 207.671C290.756 207.643 290.756 207.616 290.77 207.588C290.77 207.56 290.783 207.547 290.797 207.519V207.505C290.81 207.478 290.81 207.45 290.824 207.422C290.837 207.395 290.837 207.367 290.851 207.34C290.864 207.312 290.864 207.284 290.877 207.257C290.891 207.229 290.904 207.202 290.904 207.174C290.918 207.146 290.931 207.119 290.931 207.091C290.945 207.064 290.958 207.036 290.972 207.008C290.985 206.981 290.999 206.953 291.012 206.926C291.026 206.898 291.039 206.857 291.066 206.829C291.08 206.788 291.107 206.76 291.12 206.719C291.12 206.719 291.12 206.719 291.12 206.705C291.12 206.691 291.134 206.691 291.134 206.677C291.174 206.608 291.215 206.553 291.255 206.484C291.282 206.429 291.322 206.387 291.363 206.332C291.39 206.305 291.403 206.263 291.43 206.236C291.444 206.208 291.471 206.18 291.498 206.153C291.525 206.125 291.538 206.098 291.565 206.084C291.592 206.056 291.605 206.042 291.632 206.015L291.646 206.001C291.659 205.987 291.686 205.96 291.7 205.946C291.727 205.918 291.74 205.904 291.767 205.877C291.794 205.849 291.808 205.835 291.835 205.808C291.862 205.78 291.875 205.766 291.902 205.739C291.929 205.725 291.942 205.697 291.969 205.684C291.996 205.67 292.01 205.642 292.037 205.628C292.064 205.615 292.077 205.601 292.104 205.573C292.131 205.559 292.145 205.546 292.172 205.532C292.199 205.518 292.212 205.504 292.239 205.49C292.239 205.49 292.253 205.49 292.253 205.477C292.266 205.463 292.279 205.463 292.306 205.449C292.333 205.435 292.347 205.421 292.374 205.421C292.401 205.408 292.414 205.394 292.441 205.394C292.468 205.38 292.482 205.38 292.509 205.366C292.536 205.352 292.549 205.352 292.576 205.339C292.603 205.325 292.616 205.325 292.643 205.311C292.67 205.311 292.684 205.297 292.711 205.297C292.738 205.297 292.751 205.283 292.778 205.283C292.805 205.283 292.819 205.27 292.846 205.27C292.859 205.27 292.886 205.27 292.9 205.27H292.913C292.94 205.27 292.967 205.27 292.994 205.27C293.021 205.27 293.048 205.27 293.075 205.27C293.102 205.27 293.142 205.283 293.169 205.283C293.21 205.297 293.25 205.297 293.277 205.311C293.317 205.325 293.371 205.352 293.412 205.366L294.773 206.18C294.625 206.098 294.463 206.056 294.261 206.07C294.072 206.084 293.857 206.153 293.641 206.291C293.425 206.415 293.21 206.594 293.021 206.801C292.832 207.008 292.657 207.243 292.522 207.491C292.522 207.491 292.522 207.491 292.522 207.505C292.374 207.754 292.266 208.03 292.185 208.292C292.104 208.568 292.064 208.83 292.064 209.092C292.064 209.341 292.104 209.561 292.185 209.741C292.266 209.92 292.387 210.044 292.522 210.127L291.161 209.313C291.053 209.244 290.958 209.161 290.877 209.037C290.851 208.996 290.837 208.968 290.824 208.927C290.81 208.899 290.797 208.871 290.783 208.844C290.77 208.816 290.77 208.789 290.756 208.761C290.743 208.733 290.743 208.706 290.729 208.678C290.729 208.651 290.716 208.623 290.716 208.595C290.716 208.568 290.702 208.54 290.702 208.513C290.702 208.485 290.702 208.457 290.689 208.43C290.689 208.402 290.689 208.375 290.689 208.347C290.689 208.319 290.689 208.292 290.689 208.264C290.675 208.306 290.675 208.278 290.675 208.25Z",
    fill: "#9097C4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M293.615 206.333C292.739 206.843 292.025 208.113 292.038 209.148C292.038 210.183 292.753 210.597 293.629 210.073C294.505 209.548 295.22 208.292 295.206 207.257C295.193 206.222 294.492 205.808 293.615 206.333Z",
    fill: "url(#paint59_linear_1136_96404)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M301.325 59.0391L301.595 129.985L228.315 173.579L228.032 102.633L301.325 59.0391Z",
    fill: "url(#paint60_linear_1136_96404)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M228.032 102.633L228.315 173.579L154.551 129.985L154.268 59.0391L228.032 102.633Z",
    fill: "url(#paint61_linear_1136_96404)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M301.325 59.0416L228.032 102.636L154.268 59.0416L227.56 15.4336L301.325 59.0416Z",
    fill: "url(#paint62_linear_1136_96404)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M228.032 102.288L154.564 58.8594L154.268 59.0388L228.032 102.633L301.325 59.0388L301.028 58.8594L228.032 102.288Z",
    fill: "url(#paint63_linear_1136_96404)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M285.915 53.6094V58.8672L229.715 91.8078V86.55L285.915 53.6094Z",
    fill: "url(#paint64_linear_1136_96404)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M229.717 86.5422V91.8L171.832 57.5898V52.332L229.717 86.5422Z",
    fill: "url(#paint65_linear_1136_96404)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M285.916 53.6008L229.717 86.5414L171.832 52.3312L228.032 19.3906L285.916 53.6008Z",
    fill: "url(#paint66_linear_1136_96404)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M229.717 86.2675L172.075 52.1953L171.832 52.3333L229.717 86.5435L285.916 53.6029L285.687 53.4649L229.717 86.2675Z",
    fill: "url(#paint67_linear_1136_96404)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M213.394 108.997L213.569 152.992L167.817 125.957L167.642 81.9492L213.394 108.997Z",
    fill: "url(#paint68_linear_1136_96404)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 120.992L213.526 142.589V152.994L167.814 125.96L175.862 120.992Z",
    fill: "#7582D1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M175.971 103.2L213.23 125.266V110.086L175.971 88.0195V103.2Z",
    fill: "url(#paint69_linear_1136_96404)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M178.25 102.232L190.584 109.519V98.3958L178.25 91.1094V102.232Z",
    fill: "url(#paint70_linear_1136_96404)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M180.164 92.241V101.57L178.25 102.232V91.1094L180.164 92.241Z",
    fill: "#232D6C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M180.164 101.57L190.584 107.518V109.519L178.25 102.233L180.164 101.57Z",
    fill: "#425CFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 101.71L182.684 101.103V99.875L183.708 100.482V101.71Z",
    fill: "url(#paint71_linear_1136_96404)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M185.434 102.73L184.41 102.123V100.895L185.434 101.502V102.73Z",
    fill: "url(#paint72_linear_1136_96404)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 103.749L186.121 103.142V101.914L187.146 102.521V103.749Z",
    fill: "url(#paint73_linear_1136_96404)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 99.3724L182.684 98.7652V97.5508L183.708 98.1442V99.3724Z",
    fill: "url(#paint74_linear_1136_96404)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M185.434 100.396L184.41 99.7886V98.5742L185.434 99.1676V100.396Z",
    fill: "url(#paint75_linear_1136_96404)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 101.415L186.121 100.808V99.5938L187.146 100.187V101.415Z",
    fill: "url(#paint76_linear_1136_96404)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 97.0443L182.684 96.4371V95.2227L183.708 95.8161V97.0443Z",
    fill: "url(#paint77_linear_1136_96404)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M185.434 98.0638L184.41 97.4566V96.2422L185.434 96.8356V98.0638Z",
    fill: "url(#paint78_linear_1136_96404)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M187.146 99.0833L186.121 98.4761V97.2617L187.146 97.8551V99.0833Z",
    fill: "url(#paint79_linear_1136_96404)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M205.48 109.224L201.584 106.864C201.409 106.754 201.261 106.519 201.261 106.34C201.261 106.16 201.409 106.091 201.584 106.202L205.48 108.561C205.655 108.672 205.804 108.906 205.804 109.086C205.804 109.265 205.655 109.32 205.48 109.224Z",
    fill: "url(#paint80_linear_1136_96404)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M210.871 112.486L206.975 110.126C206.8 110.015 206.651 109.781 206.651 109.601C206.651 109.422 206.8 109.353 206.975 109.463L210.871 111.823C211.046 111.934 211.194 112.168 211.194 112.348C211.194 112.541 211.046 112.596 210.871 112.486Z",
    fill: "url(#paint81_linear_1136_96404)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M175.972 119.125L213.231 141.192V126.012L175.972 103.945V119.125Z",
    fill: "url(#paint82_linear_1136_96404)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M178.249 118.158L190.583 125.444V114.322L178.249 107.035V118.158Z",
    fill: "url(#paint83_linear_1136_96404)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M180.163 108.167V117.496L178.249 118.158V107.035L180.163 108.167Z",
    fill: "#232D6C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M180.163 117.496L190.583 123.458V125.445L178.249 118.158L180.163 117.496Z",
    fill: "#425CFF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 117.634L182.684 117.027V115.812L183.708 116.406V117.634Z",
    fill: "url(#paint84_linear_1136_96404)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 118.654L184.411 118.046V116.832L185.435 117.425V118.654Z",
    fill: "url(#paint85_linear_1136_96404)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M187.147 119.673L186.122 119.066V117.852L187.147 118.445V119.673Z",
    fill: "url(#paint86_linear_1136_96404)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 115.298L182.684 114.691V113.477L183.708 114.07V115.298Z",
    fill: "url(#paint87_linear_1136_96404)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 116.322L184.411 115.714V114.5L185.435 115.093V116.322Z",
    fill: "url(#paint88_linear_1136_96404)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M187.147 117.341L186.122 116.734V115.52L187.147 116.113V117.341Z",
    fill: "url(#paint89_linear_1136_96404)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 112.97L182.684 112.377V111.148L183.708 111.742V112.97Z",
    fill: "url(#paint90_linear_1136_96404)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M185.435 113.99L184.411 113.382V112.168L185.435 112.761V113.99Z",
    fill: "url(#paint91_linear_1136_96404)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M187.147 115.009L186.122 114.402V113.188L187.147 113.781V115.009Z",
    fill: "url(#paint92_linear_1136_96404)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M205.481 125.15L201.585 122.79C201.41 122.679 201.262 122.445 201.262 122.265C201.262 122.086 201.41 122.017 201.585 122.127L205.481 124.487C205.656 124.598 205.805 124.832 205.805 125.012C205.805 125.191 205.656 125.26 205.481 125.15Z",
    fill: "url(#paint93_linear_1136_96404)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M210.872 128.427L206.976 126.067C206.801 125.957 206.652 125.722 206.652 125.543C206.652 125.363 206.801 125.294 206.976 125.405L210.872 127.765C211.047 127.875 211.195 128.11 211.195 128.289C211.195 128.468 211.047 128.524 210.872 128.427Z",
    fill: "url(#paint94_linear_1136_96404)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4229 154.738L136.148 121.231C137.105 120.665 138.143 120.679 139.033 121.066L139.047 121.038L142.538 122.804L141.042 125.012V173.464C141.042 175.327 140.071 177.066 138.48 177.991L82.9682 210.779L80.4878 214.45L77.293 212.932C76.6729 212.573 76.228 211.911 76.228 211.083V160.396C76.228 158.063 77.4413 155.897 79.4229 154.738Z",
    fill: "url(#paint95_linear_1136_96404)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M141.243 179.333L82.1047 214.261C80.7162 215.075 78.9907 214.054 78.9907 212.412V161.724C78.9907 159.392 80.204 157.225 82.1856 156.052L138.911 122.546C141.081 121.263 143.791 122.863 143.791 125.43V174.779C143.791 176.67 142.82 178.395 141.243 179.333Z",
    fill: "url(#paint96_linear_1136_96404)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1732 156.06L138.899 122.554C140.058 121.864 141.352 122.029 142.323 122.692C141.406 122.223 140.274 122.167 139.249 122.775L82.5237 156.281C80.542 157.454 79.3288 159.607 79.3288 161.953V212.64C79.3288 213.372 79.6793 213.965 80.1916 214.351C79.4906 214.02 78.9648 213.33 78.9648 212.433V161.746C78.9783 159.386 80.205 157.233 82.1732 156.06Z",
    fill: "url(#paint97_linear_1136_96404)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0677 212.635C81.0812 212.635 81.1217 212.635 81.1621 212.607L140.3 177.68C141.298 177.086 141.918 175.982 141.918 174.809V125.46C141.918 124.577 141.19 124.039 140.53 124.039C140.287 124.039 140.058 124.108 139.842 124.232L83.1168 157.739C81.7148 158.567 80.8521 160.098 80.8521 161.754V212.442C80.8521 212.525 80.9599 212.635 81.0677 212.635Z",
    fill: "url(#paint98_linear_1136_96404)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6333 213.993L141.701 181.646C143.076 180.846 144.747 180.832 146.122 181.633L176.992 199.586L179.944 199.117V202.484L179.85 202.54C179.756 202.816 179.567 203.05 179.297 203.216L121.21 237.329C119.714 238.213 117.867 238.213 116.357 237.343L83.6137 218.299C83.1823 218.051 82.9531 217.609 82.8992 217.167L82.8857 217.154V214.573L86.6333 213.993Z",
    fill: "#303E97"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6333 213.958L141.701 181.611C143.076 180.811 144.747 180.797 146.122 181.597L176.992 199.551L179.944 199.082V202.449L179.85 202.504C179.756 202.78 179.567 203.015 179.297 203.181L121.21 237.294C119.714 238.177 117.867 238.177 116.357 237.308L83.6137 218.264C83.1823 218.016 82.9531 217.574 82.8992 217.132L82.8857 217.119V214.538L86.6333 213.958Z",
    fill: "url(#paint99_linear_1136_96404)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M116.372 234.761L83.6283 215.717C82.6577 215.151 82.6577 213.73 83.6283 213.164L141.702 179.064C143.077 178.264 144.748 178.25 146.123 179.05L179.298 198.343C180.161 198.853 180.161 200.123 179.298 200.634L121.212 234.747C119.715 235.644 117.868 235.644 116.372 234.761Z",
    fill: "url(#paint100_linear_1136_96404)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6292 215.586L116.373 234.63C117.883 235.499 119.73 235.499 121.226 234.616L179.313 200.502C179.717 200.268 179.933 199.854 179.946 199.426C179.973 199.895 179.758 200.378 179.313 200.64L121.226 234.754C119.73 235.637 117.883 235.637 116.373 234.768L83.6292 215.724C83.1169 215.434 82.8878 214.896 82.9147 214.371C82.9417 214.854 83.1708 215.323 83.6292 215.586Z",
    fill: "url(#paint101_linear_1136_96404)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M109.686 223.075L93.4148 213.801C92.6599 213.359 92.6599 212.255 93.4148 211.814L138.776 185.18C139.841 184.559 141.162 184.545 142.227 185.166L158.835 194.633C159.509 195.033 159.509 196.027 158.835 196.427L113.474 223.061C112.301 223.765 110.858 223.765 109.686 223.075Z",
    fill: "url(#paint102_linear_1136_96404)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M136.62 221.158L129.907 217.335C129.597 217.156 129.597 216.701 129.907 216.521L148.604 205.536C149.049 205.274 149.588 205.274 150.033 205.536L156.881 209.442C157.164 209.607 157.164 210.021 156.881 210.173L138.184 221.158C137.699 221.434 137.105 221.434 136.62 221.158Z",
    fill: "url(#paint103_linear_1136_96404)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M138.602 186.445L139.168 186.114C139.505 185.92 139.923 185.92 140.26 186.114L140.583 186.307L141.311 186.196V187.024L141.284 187.038C141.257 187.107 141.217 187.162 141.149 187.204L139.842 187.963C139.464 188.184 139.019 188.184 138.642 187.963L137.847 187.494C137.739 187.425 137.685 187.328 137.671 187.218V186.583L138.602 186.445Z",
    fill: "url(#paint104_linear_1136_96404)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M138.656 187.359L137.861 186.89C137.618 186.752 137.618 186.393 137.861 186.255L139.168 185.496C139.505 185.303 139.923 185.303 140.26 185.496L141.163 186.021C141.379 186.145 141.379 186.462 141.163 186.587L139.856 187.359C139.478 187.566 139.02 187.566 138.656 187.359Z",
    fill: "url(#paint105_linear_1136_96404)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M135.123 188.539L135.689 188.207C136.026 188.014 136.444 188.014 136.781 188.207L137.104 188.401L137.832 188.29V189.118L137.805 189.132C137.778 189.201 137.738 189.256 137.67 189.298L136.363 190.057C135.985 190.277 135.54 190.277 135.163 190.057L134.368 189.587C134.26 189.518 134.206 189.422 134.192 189.311V188.677L135.123 188.539Z",
    fill: "url(#paint106_linear_1136_96404)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M135.164 189.441L134.369 188.972C134.126 188.834 134.126 188.475 134.369 188.337L135.676 187.578C136.013 187.385 136.431 187.385 136.768 187.578L137.671 188.103C137.887 188.227 137.887 188.544 137.671 188.669L136.364 189.441C136 189.648 135.541 189.648 135.164 189.441Z",
    fill: "url(#paint107_linear_1136_96404)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M131.632 190.617L132.198 190.286C132.535 190.092 132.953 190.092 133.29 190.286L133.614 190.479L134.342 190.368V191.196L134.315 191.21C134.288 191.279 134.247 191.334 134.18 191.376L132.872 192.135C132.495 192.356 132.05 192.356 131.673 192.135L130.877 191.666C130.77 191.597 130.716 191.5 130.702 191.39V190.755L131.632 190.617Z",
    fill: "url(#paint108_linear_1136_96404)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M131.686 191.527L130.89 191.058C130.648 190.92 130.648 190.561 130.89 190.423L132.198 189.664C132.535 189.471 132.953 189.471 133.29 189.664L134.193 190.189C134.409 190.313 134.409 190.63 134.193 190.755L132.886 191.527C132.508 191.734 132.05 191.734 131.686 191.527Z",
    fill: "url(#paint109_linear_1136_96404)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M128.154 192.699L128.72 192.368C129.057 192.174 129.475 192.174 129.812 192.368L130.136 192.561L130.864 192.45V193.278L130.837 193.292C130.81 193.361 130.769 193.416 130.702 193.458L129.394 194.217C129.017 194.438 128.572 194.438 128.195 194.217L127.399 193.748C127.292 193.679 127.238 193.582 127.224 193.472V192.837L128.154 192.699Z",
    fill: "url(#paint110_linear_1136_96404)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M128.195 193.617L127.399 193.148C127.157 193.01 127.157 192.651 127.399 192.513L128.707 191.754C129.044 191.561 129.462 191.561 129.799 191.754L130.702 192.279C130.918 192.403 130.918 192.72 130.702 192.844L129.394 193.617C129.03 193.824 128.572 193.824 128.195 193.617Z",
    fill: "url(#paint111_linear_1136_96404)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M124.663 194.785L125.229 194.453C125.566 194.26 125.984 194.26 126.321 194.453L126.645 194.647L127.373 194.536V195.364L127.346 195.378C127.319 195.447 127.278 195.502 127.211 195.544L125.903 196.303C125.526 196.523 125.081 196.523 124.703 196.303L123.908 195.833C123.8 195.764 123.746 195.668 123.733 195.557V194.923L124.663 194.785Z",
    fill: "url(#paint112_linear_1136_96404)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M124.717 195.684L123.921 195.214C123.679 195.076 123.679 194.718 123.921 194.58L125.229 193.821C125.566 193.627 125.984 193.627 126.321 193.821L127.224 194.345C127.44 194.469 127.44 194.787 127.224 194.911L125.916 195.684C125.539 195.904 125.081 195.904 124.717 195.684Z",
    fill: "url(#paint113_linear_1136_96404)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M121.172 196.871L121.738 196.539C122.075 196.346 122.493 196.346 122.83 196.539L123.153 196.733L123.881 196.622V197.45L123.854 197.464C123.827 197.533 123.787 197.588 123.72 197.63L122.412 198.389C122.035 198.609 121.59 198.609 121.212 198.389L120.417 197.919C120.309 197.85 120.255 197.754 120.242 197.643V197.009L121.172 196.871Z",
    fill: "url(#paint114_linear_1136_96404)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M121.225 197.77L120.43 197.3C120.187 197.162 120.187 196.804 120.43 196.666L121.737 195.907C122.074 195.713 122.492 195.713 122.829 195.907L123.732 196.431C123.948 196.555 123.948 196.873 123.732 196.997L122.425 197.77C122.061 197.99 121.602 197.99 121.225 197.77Z",
    fill: "url(#paint115_linear_1136_96404)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M117.695 198.953L118.261 198.621C118.598 198.428 119.016 198.428 119.353 198.621L119.676 198.815L120.404 198.704V199.532L120.377 199.546C120.35 199.615 120.31 199.67 120.243 199.712L118.935 200.484C118.558 200.705 118.113 200.705 117.735 200.484L116.94 200.015C116.832 199.946 116.778 199.85 116.765 199.739V199.104L117.695 198.953Z",
    fill: "url(#paint116_linear_1136_96404)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M117.747 199.848L116.952 199.379C116.709 199.241 116.709 198.882 116.952 198.744L118.259 197.985C118.596 197.792 119.014 197.792 119.351 197.985L120.254 198.509C120.47 198.633 120.47 198.951 120.254 199.075L118.947 199.848C118.569 200.069 118.111 200.069 117.747 199.848Z",
    fill: "url(#paint117_linear_1136_96404)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M114.202 201.031L114.768 200.7C115.105 200.506 115.523 200.506 115.86 200.7L116.183 200.893L116.911 200.782V201.61L116.884 201.624C116.857 201.693 116.817 201.748 116.749 201.79L115.442 202.563C115.064 202.783 114.62 202.783 114.242 202.563L113.447 202.093C113.339 202.024 113.285 201.928 113.271 201.817V201.183L114.202 201.031Z",
    fill: "url(#paint118_linear_1136_96404)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M114.255 201.934L113.459 201.464C113.217 201.326 113.217 200.968 113.459 200.83L114.767 200.071C115.104 199.877 115.522 199.877 115.859 200.071L116.762 200.595C116.978 200.719 116.978 201.037 116.762 201.161L115.454 201.934C115.09 202.154 114.632 202.154 114.255 201.934Z",
    fill: "url(#paint119_linear_1136_96404)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M110.723 203.121L111.289 202.789C111.626 202.596 112.044 202.596 112.381 202.789L112.704 202.983L113.432 202.872V203.7L113.405 203.714C113.378 203.783 113.338 203.838 113.27 203.88L111.963 204.652C111.585 204.873 111.141 204.873 110.763 204.652L109.968 204.183C109.86 204.114 109.806 204.018 109.792 203.907V203.272L110.723 203.121Z",
    fill: "url(#paint120_linear_1136_96404)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M110.776 204.016L109.981 203.547C109.738 203.409 109.738 203.05 109.981 202.912L111.288 202.153C111.625 201.96 112.043 201.96 112.38 202.153L113.284 202.677C113.499 202.801 113.499 203.119 113.284 203.243L111.976 204.016C111.598 204.237 111.14 204.237 110.776 204.016Z",
    fill: "url(#paint121_linear_1136_96404)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M107.232 205.207L107.799 204.875C108.136 204.682 108.553 204.682 108.89 204.875L109.214 205.069L109.942 204.958V205.786L109.915 205.8C109.888 205.869 109.848 205.924 109.78 205.966L108.473 206.738C108.095 206.959 107.65 206.959 107.273 206.738L106.477 206.269C106.37 206.2 106.316 206.104 106.302 205.993V205.358L107.232 205.207Z",
    fill: "url(#paint122_linear_1136_96404)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M107.286 206.102L106.491 205.632C106.248 205.494 106.248 205.136 106.491 204.998L107.798 204.239C108.135 204.045 108.553 204.045 108.89 204.239L109.793 204.763C110.009 204.887 110.009 205.205 109.793 205.329L108.486 206.102C108.108 206.322 107.663 206.322 107.286 206.102Z",
    fill: "url(#paint123_linear_1136_96404)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M103.755 207.269L104.321 206.938C104.658 206.745 105.076 206.745 105.413 206.938L105.736 207.131L106.464 207.021V207.849L106.437 207.862C106.41 207.931 106.37 207.987 106.303 208.028L104.995 208.801C104.618 209.022 104.173 209.022 103.795 208.801L103 208.332C102.892 208.263 102.838 208.166 102.825 208.056V207.421L103.755 207.269Z",
    fill: "url(#paint124_linear_1136_96404)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M103.796 208.18L103 207.711C102.758 207.573 102.758 207.214 103 207.076L104.308 206.317C104.645 206.124 105.063 206.124 105.4 206.317L106.303 206.841C106.519 206.965 106.519 207.283 106.303 207.407L104.995 208.18C104.631 208.401 104.173 208.401 103.796 208.18Z",
    fill: "url(#paint125_linear_1136_96404)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M100.262 209.355L100.828 209.024C101.165 208.831 101.583 208.831 101.92 209.024L102.244 209.217L102.972 209.107V209.935L102.945 209.948C102.918 210.017 102.877 210.073 102.81 210.114L101.502 210.887C101.125 211.108 100.68 211.108 100.303 210.887L99.5073 210.418C99.3994 210.349 99.3455 210.252 99.332 210.142V209.507L100.262 209.355Z",
    fill: "url(#paint126_linear_1136_96404)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M100.316 210.266L99.5204 209.797C99.2777 209.659 99.2777 209.3 99.5204 209.162L100.828 208.403C101.165 208.21 101.583 208.21 101.92 208.403L102.823 208.927C103.039 209.051 103.039 209.369 102.823 209.493L101.515 210.266C101.138 210.487 100.693 210.487 100.316 210.266Z",
    fill: "url(#paint127_linear_1136_96404)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7856 211.441L97.3518 211.11C97.6888 210.917 98.1067 210.917 98.4437 211.11L98.7672 211.303L99.4952 211.193V212.021L99.4682 212.034C99.4412 212.103 99.4008 212.159 99.3334 212.2L98.0258 212.973C97.6484 213.194 97.2035 213.194 96.8261 212.973L96.0307 212.504C95.9229 212.435 95.8689 212.338 95.8555 212.228V211.593L96.7856 211.441Z",
    fill: "url(#paint128_linear_1136_96404)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8265 212.352L96.0311 211.882C95.7885 211.744 95.7885 211.386 96.0311 211.248L97.3387 210.489C97.6757 210.295 98.0936 210.295 98.4306 210.489L99.3338 211.013C99.5495 211.137 99.5495 211.455 99.3338 211.579L98.0262 212.352C97.6622 212.572 97.2039 212.572 96.8265 212.352Z",
    fill: "url(#paint129_linear_1136_96404)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M141.606 188.164L142.172 187.832C142.509 187.639 142.927 187.639 143.264 187.832L143.587 188.026L144.315 187.915V188.743L144.288 188.757C144.261 188.826 144.221 188.881 144.153 188.923L139.354 191.765C138.977 191.986 138.532 191.986 138.155 191.765L137.359 191.296C137.251 191.227 137.198 191.131 137.184 191.02V190.385L141.606 188.164Z",
    fill: "url(#paint130_linear_1136_96404)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M138.168 191.158L137.373 190.689C137.13 190.551 137.13 190.192 137.373 190.054L142.172 187.211C142.509 187.018 142.927 187.018 143.264 187.211L144.167 187.736C144.383 187.86 144.383 188.177 144.167 188.302L139.368 191.144C138.991 191.365 138.532 191.379 138.168 191.158Z",
    fill: "url(#paint131_linear_1136_96404)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M134.636 192.332L135.202 192C135.539 191.807 135.957 191.807 136.294 192L136.618 192.194L137.346 192.083V192.911L137.319 192.925C137.292 192.994 137.251 193.049 137.184 193.091L135.876 193.863C135.499 194.084 135.054 194.084 134.677 193.863L133.881 193.394C133.773 193.325 133.72 193.229 133.706 193.118V192.483L134.636 192.332Z",
    fill: "url(#paint132_linear_1136_96404)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M134.677 193.242L133.882 192.773C133.639 192.635 133.639 192.276 133.882 192.138L135.189 191.379C135.526 191.186 135.944 191.186 136.281 191.379L137.184 191.904C137.4 192.028 137.4 192.345 137.184 192.469L135.877 193.242C135.513 193.449 135.054 193.449 134.677 193.242Z",
    fill: "url(#paint133_linear_1136_96404)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M131.144 194.414L131.71 194.082C132.047 193.889 132.465 193.889 132.802 194.082L133.125 194.276L133.853 194.165V194.993L133.826 195.007C133.799 195.076 133.759 195.131 133.691 195.173L132.384 195.945C132.006 196.166 131.561 196.166 131.184 195.945L130.389 195.476C130.281 195.407 130.227 195.311 130.213 195.2V194.565L131.144 194.414Z",
    fill: "url(#paint134_linear_1136_96404)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M131.199 195.324L130.404 194.855C130.161 194.717 130.161 194.358 130.404 194.22L131.711 193.461C132.048 193.268 132.466 193.268 132.803 193.461L133.706 193.986C133.922 194.11 133.922 194.427 133.706 194.552L132.399 195.324C132.021 195.531 131.563 195.531 131.199 195.324Z",
    fill: "url(#paint135_linear_1136_96404)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M127.654 196.5L128.22 196.168C128.557 195.975 128.975 195.975 129.312 196.168L129.636 196.362L130.364 196.251V197.079L130.337 197.093C130.31 197.162 130.269 197.217 130.202 197.259L128.894 198.031C128.517 198.252 128.072 198.252 127.695 198.031L126.899 197.562C126.792 197.493 126.738 197.397 126.724 197.286V196.651L127.654 196.5Z",
    fill: "url(#paint136_linear_1136_96404)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M127.708 197.414L126.912 196.945C126.67 196.807 126.67 196.448 126.912 196.31L128.22 195.551C128.557 195.358 128.975 195.358 129.312 195.551L130.215 196.076C130.431 196.2 130.431 196.517 130.215 196.641L128.908 197.414C128.544 197.621 128.085 197.621 127.708 197.414Z",
    fill: "url(#paint137_linear_1136_96404)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M124.176 198.578L124.742 198.246C125.079 198.053 125.497 198.053 125.834 198.246L126.158 198.44L126.886 198.329V199.157L126.859 199.171C126.832 199.24 126.791 199.295 126.724 199.337L125.416 200.109C125.039 200.33 124.594 200.33 124.217 200.109L123.421 199.64C123.313 199.571 123.26 199.475 123.246 199.364V198.729L124.176 198.578Z",
    fill: "url(#paint138_linear_1136_96404)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M124.23 199.488L123.434 199.019C123.192 198.881 123.192 198.522 123.434 198.384L124.742 197.625C125.079 197.432 125.497 197.432 125.834 197.625L126.737 198.15C126.953 198.274 126.953 198.591 126.737 198.716L125.43 199.488C125.052 199.695 124.594 199.695 124.23 199.488Z",
    fill: "url(#paint139_linear_1136_96404)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M120.683 200.671L121.249 200.34C121.586 200.147 122.004 200.147 122.341 200.34L122.665 200.533L123.393 200.423V201.251L123.366 201.265C123.339 201.334 123.298 201.389 123.231 201.43L121.923 202.203C121.546 202.424 121.101 202.424 120.724 202.203L119.928 201.734C119.82 201.665 119.766 201.568 119.753 201.458V200.823L120.683 200.671Z",
    fill: "url(#paint140_linear_1136_96404)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M120.737 201.582L119.941 201.113C119.699 200.975 119.699 200.616 119.941 200.478L121.249 199.719C121.586 199.526 122.004 199.526 122.341 199.719L123.244 200.244C123.46 200.368 123.46 200.685 123.244 200.809L121.936 201.582C121.572 201.789 121.114 201.789 120.737 201.582Z",
    fill: "url(#paint141_linear_1136_96404)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M117.208 202.75L117.774 202.418C118.111 202.225 118.529 202.225 118.866 202.418L119.19 202.612L119.918 202.501V203.329L119.891 203.343C119.864 203.412 119.823 203.467 119.756 203.509L118.448 204.281C118.071 204.502 117.626 204.502 117.248 204.281L116.453 203.812C116.345 203.743 116.291 203.647 116.278 203.536V202.901L117.208 202.75Z",
    fill: "url(#paint142_linear_1136_96404)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M117.262 203.645L116.466 203.175C116.224 203.037 116.224 202.679 116.466 202.541L117.774 201.782C118.111 201.588 118.529 201.588 118.866 201.782L119.769 202.306C119.985 202.43 119.985 202.748 119.769 202.872L118.461 203.645C118.084 203.865 117.625 203.865 117.262 203.645Z",
    fill: "url(#paint143_linear_1136_96404)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M113.713 204.835L114.28 204.504C114.617 204.311 115.034 204.311 115.371 204.504L115.695 204.697L116.423 204.587V205.415L116.396 205.429C116.369 205.498 116.329 205.553 116.261 205.594L114.954 206.367C114.576 206.588 114.131 206.588 113.754 206.367L112.958 205.898C112.851 205.829 112.797 205.732 112.783 205.622V204.987L113.713 204.835Z",
    fill: "url(#paint144_linear_1136_96404)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M113.767 205.731L112.972 205.261C112.729 205.123 112.729 204.765 112.972 204.627L114.279 203.868C114.616 203.674 115.034 203.674 115.371 203.868L116.274 204.392C116.49 204.516 116.49 204.834 116.274 204.958L114.967 205.731C114.603 205.951 114.144 205.951 113.767 205.731Z",
    fill: "url(#paint145_linear_1136_96404)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M110.238 206.918L110.804 206.586C111.141 206.393 111.559 206.393 111.896 206.586L112.219 206.78L112.947 206.669V207.497L112.92 207.511C112.893 207.58 112.853 207.635 112.786 207.677L111.478 208.449C111.101 208.67 110.656 208.67 110.278 208.449L109.483 207.98C109.375 207.911 109.321 207.815 109.308 207.704V207.069L110.238 206.918Z",
    fill: "url(#paint146_linear_1136_96404)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M110.292 207.813L109.496 207.343C109.254 207.205 109.254 206.847 109.496 206.709L110.804 205.95C111.141 205.756 111.559 205.756 111.896 205.95L112.799 206.474C113.015 206.598 113.015 206.916 112.799 207.04L111.492 207.813C111.114 208.033 110.656 208.033 110.292 207.813Z",
    fill: "url(#paint147_linear_1136_96404)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M106.747 209.003L107.313 208.672C107.65 208.479 108.068 208.479 108.405 208.672L108.728 208.865L109.456 208.755V209.583L109.429 209.597C109.402 209.666 109.362 209.721 109.294 209.762L107.987 210.521C107.609 210.742 107.164 210.742 106.787 210.521L105.992 210.052C105.884 209.983 105.83 209.887 105.816 209.776V209.141L106.747 209.003Z",
    fill: "url(#paint148_linear_1136_96404)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M106.801 209.899L106.006 209.429C105.763 209.291 105.763 208.933 106.006 208.795L107.313 208.036C107.65 207.842 108.068 207.842 108.405 208.036L109.308 208.56C109.524 208.684 109.524 209.002 109.308 209.126L108.001 209.899C107.623 210.119 107.179 210.119 106.801 209.899Z",
    fill: "url(#paint149_linear_1136_96404)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7752 213.173L103.819 210.758C104.156 210.565 104.574 210.565 104.911 210.758L105.235 210.951L105.963 210.841V211.669L105.936 211.683C105.909 211.752 105.868 211.807 105.801 211.848L101.002 214.691C100.624 214.912 100.18 214.912 99.8021 214.691L99.0068 214.222C98.8989 214.153 98.845 214.056 98.8315 213.946V213.311L99.7752 213.173Z",
    fill: "url(#paint150_linear_1136_96404)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8294 214.068L99.034 213.599C98.7914 213.461 98.7914 213.102 99.034 212.964L103.833 210.121C104.17 209.928 104.588 209.928 104.925 210.121L105.828 210.646C106.044 210.77 106.044 211.087 105.828 211.212L101.029 214.054C100.652 214.289 100.207 214.289 99.8294 214.068Z",
    fill: "url(#paint151_linear_1136_96404)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M144.599 189.886L145.165 189.555C145.502 189.362 145.92 189.362 146.257 189.555L146.581 189.748L147.309 189.638V190.466L147.282 190.48C147.255 190.549 147.214 190.604 147.147 190.645L145.839 191.418C145.462 191.639 145.017 191.639 144.64 191.418L143.844 190.949C143.736 190.88 143.682 190.783 143.669 190.673V190.038L144.599 189.886Z",
    fill: "url(#paint152_linear_1136_96404)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M144.654 190.781L143.858 190.312C143.616 190.174 143.616 189.815 143.858 189.677L145.166 188.918C145.503 188.725 145.921 188.725 146.258 188.918L147.161 189.443C147.377 189.567 147.377 189.884 147.161 190.009L145.853 190.781C145.476 191.002 145.018 191.002 144.654 190.781Z",
    fill: "url(#paint153_linear_1136_96404)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M141.122 191.953L141.688 191.621C142.025 191.428 142.443 191.428 142.78 191.621L143.104 191.815L143.832 191.704V192.532L143.805 192.546C143.778 192.615 143.737 192.67 143.67 192.712L142.362 193.484C141.985 193.705 141.54 193.705 141.162 193.484L140.367 193.015C140.259 192.946 140.205 192.85 140.192 192.739V192.104L141.122 191.953Z",
    fill: "url(#paint154_linear_1136_96404)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M141.161 192.867L140.366 192.398C140.123 192.26 140.123 191.901 140.366 191.763L141.673 191.004C142.01 190.811 142.428 190.811 142.765 191.004L143.668 191.529C143.884 191.653 143.884 191.97 143.668 192.094L142.361 192.867C141.997 193.088 141.538 193.088 141.161 192.867Z",
    fill: "url(#paint155_linear_1136_96404)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M137.63 194.039L138.196 193.707C138.533 193.514 138.951 193.514 139.288 193.707L139.611 193.901L140.339 193.79V194.618L140.312 194.632C140.285 194.701 140.245 194.756 140.178 194.798L138.87 195.557C138.493 195.777 138.048 195.777 137.67 195.557L136.875 195.087C136.767 195.018 136.713 194.922 136.7 194.811V194.177L137.63 194.039Z",
    fill: "url(#paint156_linear_1136_96404)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M137.684 194.949L136.889 194.48C136.646 194.342 136.646 193.983 136.889 193.845L138.196 193.086C138.533 192.893 138.951 192.893 139.288 193.086L140.191 193.611C140.407 193.735 140.407 194.052 140.191 194.177L138.884 194.949C138.506 195.17 138.048 195.17 137.684 194.949Z",
    fill: "url(#paint157_linear_1136_96404)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M134.152 196.121L134.718 195.789C135.055 195.596 135.473 195.596 135.81 195.789L136.133 195.983L136.861 195.872V196.7L136.834 196.714C136.807 196.783 136.767 196.838 136.7 196.88L135.392 197.652C135.015 197.873 134.57 197.873 134.192 197.652L133.397 197.183C133.289 197.114 133.235 197.018 133.222 196.907V196.272L134.152 196.121Z",
    fill: "url(#paint158_linear_1136_96404)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M134.192 197.031L133.396 196.562C133.154 196.424 133.154 196.065 133.396 195.927L134.704 195.168C135.041 194.975 135.459 194.975 135.796 195.168L136.699 195.693C136.915 195.817 136.915 196.134 136.699 196.259L135.391 197.031C135.027 197.252 134.569 197.252 134.192 197.031Z",
    fill: "url(#paint159_linear_1136_96404)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M130.659 198.207L131.225 197.875C131.562 197.682 131.98 197.682 132.317 197.875L132.641 198.069L133.369 197.958V198.786L133.342 198.8C133.315 198.869 133.274 198.924 133.207 198.966L131.899 199.725C131.522 199.945 131.077 199.945 130.7 199.725L129.904 199.255C129.796 199.186 129.742 199.09 129.729 198.979V198.345L130.659 198.207Z",
    fill: "url(#paint160_linear_1136_96404)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M130.714 199.121L129.918 198.652C129.676 198.514 129.676 198.155 129.918 198.017L131.226 197.258C131.563 197.065 131.981 197.065 132.318 197.258L133.221 197.783C133.437 197.907 133.437 198.224 133.221 198.348L131.913 199.121C131.536 199.328 131.078 199.342 130.714 199.121Z",
    fill: "url(#paint161_linear_1136_96404)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M127.169 200.285L127.735 199.953C128.072 199.76 128.49 199.76 128.827 199.953L129.151 200.147L129.878 200.036V200.864L129.852 200.878C129.825 200.947 129.784 201.002 129.717 201.044L128.409 201.803C128.032 202.023 127.587 202.023 127.209 201.803L126.414 201.333C126.306 201.264 126.252 201.168 126.239 201.057V200.423L127.169 200.285Z",
    fill: "url(#paint162_linear_1136_96404)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M127.223 201.195L126.428 200.726C126.185 200.588 126.185 200.229 126.428 200.091L127.736 199.332C128.073 199.139 128.491 199.139 128.828 199.332L129.731 199.857C129.946 199.981 129.946 200.298 129.731 200.423L128.423 201.195C128.059 201.402 127.601 201.402 127.223 201.195Z",
    fill: "url(#paint163_linear_1136_96404)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M123.691 202.371L124.257 202.039C124.594 201.846 125.012 201.846 125.349 202.039L125.673 202.233L126.4 202.122V202.95L126.373 202.964C126.347 203.033 126.306 203.088 126.239 203.13L124.931 203.889C124.554 204.109 124.109 204.109 123.731 203.889L122.936 203.419C122.828 203.35 122.774 203.254 122.761 203.143V202.509L123.691 202.371Z",
    fill: "url(#paint164_linear_1136_96404)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M123.745 203.285L122.95 202.816C122.707 202.678 122.707 202.319 122.95 202.181L124.258 201.422C124.595 201.229 125.013 201.229 125.35 201.422L126.253 201.947C126.468 202.071 126.468 202.388 126.253 202.512L124.945 203.285C124.568 203.492 124.109 203.492 123.745 203.285Z",
    fill: "url(#paint165_linear_1136_96404)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M120.198 204.457L120.764 204.125C121.101 203.932 121.519 203.932 121.856 204.125L122.179 204.319L122.907 204.208V205.036L122.88 205.05C122.853 205.119 122.813 205.174 122.746 205.216L121.438 205.975C121.06 206.195 120.616 206.195 120.238 205.975L119.443 205.505C119.335 205.436 119.281 205.34 119.268 205.229V204.595L120.198 204.457Z",
    fill: "url(#paint166_linear_1136_96404)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M120.253 205.367L119.458 204.898C119.215 204.76 119.215 204.401 119.458 204.263L120.765 203.504C121.102 203.311 121.52 203.311 121.857 203.504L122.761 204.029C122.976 204.153 122.976 204.47 122.761 204.594L121.453 205.367C121.089 205.574 120.631 205.574 120.253 205.367Z",
    fill: "url(#paint167_linear_1136_96404)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M116.72 206.539L117.286 206.207C117.623 206.014 118.041 206.014 118.378 206.207L118.702 206.401L119.43 206.29V207.118L119.403 207.132C119.376 207.201 119.335 207.256 119.268 207.298L117.96 208.057C117.583 208.277 117.138 208.277 116.761 208.057L115.965 207.587C115.857 207.518 115.804 207.422 115.79 207.311V206.677L116.72 206.539Z",
    fill: "url(#paint168_linear_1136_96404)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M116.774 207.449L115.978 206.98C115.736 206.842 115.736 206.483 115.978 206.345L117.286 205.586C117.623 205.393 118.041 205.393 118.378 205.586L119.281 206.111C119.497 206.235 119.497 206.552 119.281 206.676L117.973 207.449C117.596 207.656 117.138 207.656 116.774 207.449Z",
    fill: "url(#paint169_linear_1136_96404)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M113.232 208.625L113.798 208.293C114.135 208.1 114.553 208.1 114.89 208.293L115.214 208.487L115.941 208.376V209.204L115.914 209.218C115.888 209.287 115.847 209.342 115.78 209.384L114.472 210.156C114.095 210.377 113.65 210.377 113.272 210.156L112.477 209.687C112.369 209.618 112.315 209.522 112.302 209.411V208.776L113.232 208.625Z",
    fill: "url(#paint170_linear_1136_96404)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M113.285 209.535L112.49 209.066C112.247 208.928 112.247 208.569 112.49 208.431L113.798 207.672C114.135 207.479 114.553 207.479 114.89 207.672L115.793 208.197C116.008 208.321 116.008 208.638 115.793 208.762L114.485 209.535C114.121 209.742 113.663 209.742 113.285 209.535Z",
    fill: "url(#paint171_linear_1136_96404)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M109.75 210.714L110.317 210.383C110.654 210.19 111.072 210.19 111.409 210.383L111.732 210.576L112.46 210.466V211.294L112.433 211.308C112.406 211.377 112.366 211.432 112.298 211.473L110.991 212.232C110.613 212.453 110.168 212.453 109.791 212.232L108.996 211.763C108.888 211.694 108.834 211.598 108.82 211.487V210.852L109.75 210.714Z",
    fill: "url(#paint172_linear_1136_96404)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M109.791 211.609L108.996 211.14C108.753 211.002 108.753 210.643 108.996 210.505L110.304 209.746C110.641 209.553 111.058 209.553 111.395 209.746L112.299 210.271C112.514 210.395 112.514 210.712 112.299 210.837L110.991 211.609C110.627 211.83 110.169 211.83 109.791 211.609Z",
    fill: "url(#paint173_linear_1136_96404)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M106.26 212.793L106.826 212.461C107.163 212.268 107.581 212.268 107.918 212.461L108.242 212.655L108.97 212.544V213.372L108.943 213.386C108.916 213.455 108.875 213.51 108.808 213.552L107.5 214.324C107.123 214.545 106.678 214.545 106.301 214.324L105.505 213.855C105.397 213.786 105.344 213.69 105.33 213.579V212.944L106.26 212.793Z",
    fill: "url(#paint174_linear_1136_96404)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M106.313 213.688L105.518 213.218C105.275 213.08 105.275 212.722 105.518 212.584L106.826 211.825C107.163 211.631 107.58 211.631 107.917 211.825L108.821 212.349C109.036 212.473 109.036 212.791 108.821 212.915L107.513 213.688C107.136 213.908 106.691 213.908 106.313 213.688Z",
    fill: "url(#paint175_linear_1136_96404)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M102.782 214.871L103.348 214.539C103.685 214.346 104.103 214.346 104.44 214.539L104.764 214.733L105.492 214.622V215.45L105.465 215.464C105.438 215.533 105.397 215.588 105.33 215.63L104.022 216.402C103.645 216.623 103.2 216.623 102.823 216.402L102.027 215.933C101.919 215.864 101.866 215.768 101.852 215.657V215.022L102.782 214.871Z",
    fill: "url(#paint176_linear_1136_96404)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M102.823 215.766L102.028 215.297C101.785 215.159 101.785 214.8 102.028 214.662L103.335 213.903C103.672 213.71 104.09 213.71 104.427 213.903L105.33 214.427C105.546 214.551 105.546 214.869 105.33 214.993L104.023 215.766C103.659 215.987 103.2 215.987 102.823 215.766Z",
    fill: "url(#paint177_linear_1136_96404)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M147.606 191.597L148.172 191.266C148.509 191.073 148.927 191.073 149.264 191.266L149.588 191.459L150.315 191.349V192.177L150.289 192.191C150.262 192.26 150.221 192.315 150.154 192.356L148.846 193.115C148.469 193.336 148.024 193.336 147.646 193.115L146.851 192.646C146.743 192.577 146.689 192.48 146.676 192.37V191.735L147.606 191.597Z",
    fill: "url(#paint178_linear_1136_96404)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M147.647 192.492L146.851 192.023C146.609 191.885 146.609 191.526 146.851 191.388L148.159 190.629C148.496 190.436 148.914 190.436 149.251 190.629L150.154 191.154C150.37 191.278 150.37 191.595 150.154 191.719L148.847 192.492C148.483 192.713 148.024 192.713 147.647 192.492Z",
    fill: "url(#paint179_linear_1136_96404)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M144.117 193.683L144.683 193.352C145.02 193.159 145.438 193.159 145.775 193.352L146.098 193.545L146.826 193.435V194.263L146.799 194.277C146.772 194.346 146.732 194.401 146.664 194.442L145.357 195.201C144.979 195.422 144.535 195.422 144.157 195.201L143.362 194.732C143.254 194.663 143.2 194.566 143.187 194.456V193.821L144.117 193.683Z",
    fill: "url(#paint180_linear_1136_96404)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M144.17 194.578L143.375 194.109C143.132 193.971 143.132 193.612 143.375 193.474L144.682 192.715C145.019 192.522 145.437 192.522 145.774 192.715L146.678 193.24C146.893 193.364 146.893 193.681 146.678 193.805L145.37 194.578C144.993 194.799 144.534 194.799 144.17 194.578Z",
    fill: "url(#paint181_linear_1136_96404)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M140.638 195.761L141.204 195.43C141.541 195.237 141.959 195.237 142.296 195.43L142.619 195.623L143.347 195.513V196.341L143.32 196.355C143.293 196.424 143.253 196.479 143.185 196.52L141.878 197.293C141.5 197.514 141.056 197.514 140.678 197.293L139.883 196.824C139.775 196.755 139.721 196.658 139.708 196.548V195.913L140.638 195.761Z",
    fill: "url(#paint182_linear_1136_96404)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M140.678 196.66L139.883 196.191C139.641 196.053 139.641 195.694 139.883 195.556L141.191 194.797C141.528 194.604 141.946 194.604 142.283 194.797L143.186 195.322C143.402 195.446 143.402 195.763 143.186 195.887L141.878 196.66C141.514 196.881 141.056 196.881 140.678 196.66Z",
    fill: "url(#paint183_linear_1136_96404)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M137.147 197.847L137.714 197.516C138.051 197.323 138.469 197.323 138.806 197.516L139.129 197.709L139.857 197.599V198.427L139.83 198.441C139.803 198.51 139.763 198.565 139.695 198.606L138.388 199.379C138.01 199.6 137.565 199.6 137.188 199.379L136.393 198.91C136.285 198.841 136.231 198.744 136.217 198.634V197.999L137.147 197.847Z",
    fill: "url(#paint184_linear_1136_96404)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M137.199 198.742L136.404 198.273C136.162 198.135 136.162 197.776 136.404 197.638L137.712 196.879C138.049 196.686 138.467 196.686 138.804 196.879L139.707 197.404C139.923 197.528 139.923 197.845 139.707 197.969L138.399 198.742C138.022 198.963 137.563 198.963 137.199 198.742Z",
    fill: "url(#paint185_linear_1136_96404)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M133.668 199.917L134.235 199.586C134.572 199.393 134.99 199.393 135.327 199.586L135.65 199.779L136.378 199.669V200.497L136.351 200.511C136.324 200.58 136.284 200.635 136.216 200.676L134.909 201.449C134.531 201.67 134.086 201.67 133.709 201.449L132.914 200.98C132.806 200.911 132.752 200.815 132.738 200.704V200.069L133.668 199.917Z",
    fill: "url(#paint186_linear_1136_96404)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M133.709 200.832L132.914 200.363C132.671 200.225 132.671 199.866 132.914 199.728L134.222 198.969C134.559 198.776 134.976 198.776 135.313 198.969L136.217 199.494C136.432 199.618 136.432 199.935 136.217 200.059L134.909 200.832C134.545 201.053 134.087 201.053 133.709 200.832Z",
    fill: "url(#paint187_linear_1136_96404)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M130.177 201.996L130.743 201.664C131.08 201.471 131.498 201.471 131.835 201.664L132.159 201.858L132.887 201.747V202.575L132.86 202.589C132.833 202.658 132.792 202.713 132.725 202.755L131.417 203.527C131.04 203.748 130.595 203.748 130.218 203.527L129.422 203.058C129.314 202.989 129.261 202.893 129.247 202.782V202.147L130.177 201.996Z",
    fill: "url(#paint188_linear_1136_96404)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M130.231 202.906L129.436 202.437C129.193 202.299 129.193 201.94 129.436 201.802L130.743 201.043C131.08 200.85 131.498 200.85 131.835 201.043L132.739 201.568C132.954 201.692 132.954 202.009 132.739 202.134L131.431 202.906C131.054 203.127 130.595 203.127 130.231 202.906Z",
    fill: "url(#paint189_linear_1136_96404)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M126.684 204.085L127.25 203.754C127.587 203.561 128.005 203.561 128.342 203.754L128.666 203.947L129.394 203.837V204.665L129.367 204.679C129.34 204.748 129.299 204.803 129.232 204.844L127.924 205.617C127.547 205.838 127.102 205.838 126.724 205.617L125.929 205.148C125.821 205.079 125.767 204.982 125.754 204.872V204.237L126.684 204.085Z",
    fill: "url(#paint190_linear_1136_96404)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M126.738 204.996L125.942 204.527C125.7 204.389 125.7 204.03 125.942 203.892L127.25 203.133C127.587 202.94 128.005 202.94 128.342 203.133L129.245 203.658C129.461 203.782 129.461 204.099 129.245 204.223L127.937 204.996C127.573 205.217 127.115 205.217 126.738 204.996Z",
    fill: "url(#paint191_linear_1136_96404)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M123.209 206.171L123.775 205.84C124.112 205.647 124.53 205.647 124.867 205.84L125.191 206.033L125.919 205.923V206.751L125.892 206.765C125.865 206.834 125.824 206.889 125.757 206.93L124.449 207.703C124.072 207.924 123.627 207.924 123.249 207.703L122.454 207.234C122.346 207.165 122.292 207.068 122.279 206.958V206.323L123.209 206.171Z",
    fill: "url(#paint192_linear_1136_96404)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M123.262 207.082L122.467 206.613C122.224 206.475 122.224 206.116 122.467 205.978L123.775 205.219C124.112 205.026 124.53 205.026 124.867 205.219L125.77 205.744C125.986 205.868 125.986 206.185 125.77 206.309L124.462 207.082C124.085 207.289 123.626 207.303 123.262 207.082Z",
    fill: "url(#paint193_linear_1136_96404)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M119.716 208.253L120.282 207.922C120.619 207.729 121.037 207.729 121.374 207.922L121.698 208.115L122.426 208.005V208.833L122.399 208.847C122.372 208.916 122.331 208.971 122.264 209.012L120.956 209.785C120.579 210.006 120.134 210.006 119.757 209.785L118.961 209.316C118.854 209.247 118.8 209.15 118.786 209.04V208.405L119.716 208.253Z",
    fill: "url(#paint194_linear_1136_96404)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M119.769 209.164L118.974 208.695C118.731 208.557 118.731 208.198 118.974 208.06L120.282 207.301C120.619 207.108 121.036 207.108 121.373 207.301L122.277 207.826C122.492 207.95 122.492 208.267 122.277 208.391L120.969 209.164C120.605 209.371 120.147 209.371 119.769 209.164Z",
    fill: "url(#paint195_linear_1136_96404)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M116.239 210.328L116.805 209.996C117.142 209.803 117.56 209.803 117.897 209.996L118.22 210.19L118.948 210.079V210.907L118.921 210.921C118.894 210.99 118.854 211.045 118.787 211.087L117.479 211.859C117.101 212.08 116.657 212.08 116.279 211.859L115.484 211.39C115.376 211.321 115.322 211.225 115.309 211.114V210.479L116.239 210.328Z",
    fill: "url(#paint196_linear_1136_96404)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M116.292 211.238L115.497 210.769C115.254 210.631 115.254 210.272 115.497 210.134L116.805 209.375C117.142 209.182 117.559 209.182 117.896 209.375L118.8 209.9C119.015 210.024 119.015 210.341 118.8 210.466L117.492 211.238C117.115 211.445 116.656 211.445 116.292 211.238Z",
    fill: "url(#paint197_linear_1136_96404)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M112.748 212.421L113.314 212.09C113.651 211.897 114.069 211.897 114.406 212.09L114.729 212.283L115.457 212.173V213.001L115.43 213.015C115.403 213.084 115.363 213.139 115.295 213.18L113.988 213.953C113.61 214.174 113.165 214.174 112.788 213.953L111.993 213.484C111.885 213.415 111.831 213.318 111.817 213.208V212.573L112.748 212.421Z",
    fill: "url(#paint198_linear_1136_96404)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M112.801 213.332L112.006 212.863C111.763 212.725 111.763 212.366 112.006 212.228L113.313 211.469C113.65 211.276 114.068 211.276 114.405 211.469L115.308 211.994C115.524 212.118 115.524 212.435 115.308 212.559L114.001 213.332C113.623 213.539 113.179 213.539 112.801 213.332Z",
    fill: "url(#paint199_linear_1136_96404)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M105.777 216.583L109.821 214.168C110.158 213.975 110.576 213.975 110.913 214.168L111.237 214.362L111.965 214.251V215.079L111.938 215.093C111.911 215.162 111.87 215.217 111.803 215.259L107.004 218.101C106.626 218.322 106.182 218.322 105.804 218.101L105.009 217.632C104.901 217.563 104.847 217.467 104.833 217.356V216.721L105.777 216.583Z",
    fill: "url(#paint200_linear_1136_96404)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M105.831 217.494L105.036 217.025C104.793 216.887 104.793 216.528 105.036 216.39L109.835 213.547C110.172 213.354 110.59 213.354 110.927 213.547L111.83 214.072C112.046 214.196 112.046 214.513 111.83 214.637L107.031 217.48C106.654 217.701 106.209 217.701 105.831 217.494Z",
    fill: "url(#paint201_linear_1136_96404)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M143.628 197.476L144.195 197.145C144.532 196.952 144.949 196.952 145.286 197.145L145.61 197.338L146.338 197.228V198.056L146.311 198.07C146.284 198.139 146.244 198.194 146.176 198.235L144.869 199.008C144.491 199.229 144.046 199.229 143.669 199.008L142.873 198.539C142.766 198.47 142.712 198.373 142.698 198.263V197.628L143.628 197.476Z",
    fill: "url(#paint202_linear_1136_96404)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M143.682 198.367L142.887 197.898C142.644 197.76 142.644 197.401 142.887 197.263L144.195 196.504C144.532 196.311 144.95 196.311 145.287 196.504L146.19 197.029C146.405 197.153 146.405 197.47 146.19 197.594L144.882 198.367C144.505 198.588 144.046 198.588 143.682 198.367Z",
    fill: "url(#paint203_linear_1136_96404)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M140.152 199.554L140.718 199.223C141.055 199.03 141.473 199.03 141.81 199.223L142.134 199.416L142.862 199.306V200.134L142.835 200.148C142.808 200.217 142.767 200.272 142.7 200.313L141.393 201.086C141.015 201.307 140.57 201.307 140.193 201.086L139.397 200.617C139.29 200.548 139.236 200.451 139.222 200.341V199.706L140.152 199.554Z",
    fill: "url(#paint204_linear_1136_96404)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M140.193 200.457L139.398 199.988C139.155 199.85 139.155 199.491 139.398 199.353L140.705 198.594C141.042 198.401 141.46 198.401 141.797 198.594L142.7 199.119C142.916 199.243 142.916 199.56 142.7 199.684L141.393 200.457C141.029 200.678 140.571 200.678 140.193 200.457Z",
    fill: "url(#paint205_linear_1136_96404)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M136.66 201.644L137.226 201.313C137.563 201.12 137.981 201.12 138.318 201.313L138.642 201.506L139.37 201.396V202.224L139.343 202.237C139.316 202.306 139.275 202.362 139.208 202.403L137.9 203.176C137.523 203.397 137.078 203.397 136.701 203.176L135.905 202.707C135.797 202.638 135.743 202.541 135.73 202.431V201.796L136.66 201.644Z",
    fill: "url(#paint206_linear_1136_96404)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M136.712 202.535L135.917 202.066C135.674 201.928 135.674 201.569 135.917 201.431L137.224 200.672C137.561 200.479 137.979 200.479 138.316 200.672L139.22 201.197C139.435 201.321 139.435 201.638 139.22 201.762L137.912 202.535C137.534 202.756 137.076 202.756 136.712 202.535Z",
    fill: "url(#paint207_linear_1136_96404)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M133.169 203.726L133.735 203.395C134.072 203.202 134.49 203.202 134.827 203.395L135.151 203.588L135.878 203.478V204.306L135.852 204.319C135.825 204.388 135.784 204.444 135.717 204.485L134.409 205.258C134.032 205.479 133.587 205.479 133.209 205.258L132.414 204.789C132.306 204.72 132.252 204.623 132.239 204.513V203.878L133.169 203.726Z",
    fill: "url(#paint208_linear_1136_96404)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M133.223 204.621L132.428 204.152C132.185 204.014 132.185 203.655 132.428 203.517L133.735 202.758C134.072 202.565 134.49 202.565 134.827 202.758L135.73 203.283C135.946 203.407 135.946 203.724 135.73 203.848L134.423 204.621C134.059 204.842 133.6 204.842 133.223 204.621Z",
    fill: "url(#paint209_linear_1136_96404)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M129.689 205.804L130.256 205.473C130.593 205.28 131.01 205.28 131.348 205.473L131.671 205.666L132.399 205.556V206.384L132.372 206.398C132.345 206.467 132.305 206.522 132.237 206.563L130.93 207.336C130.552 207.557 130.107 207.557 129.73 207.336L128.935 206.867C128.827 206.798 128.773 206.701 128.759 206.591V205.956L129.689 205.804Z",
    fill: "url(#paint210_linear_1136_96404)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M129.746 206.703L128.951 206.234C128.708 206.096 128.708 205.737 128.951 205.599L130.258 204.84C130.595 204.647 131.013 204.647 131.35 204.84L132.253 205.365C132.469 205.489 132.469 205.806 132.253 205.93L130.946 206.703C130.568 206.924 130.11 206.924 129.746 206.703Z",
    fill: "url(#paint211_linear_1136_96404)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M126.197 207.875L126.763 207.543C127.1 207.35 127.518 207.35 127.855 207.543L128.179 207.737L128.907 207.626V208.454L128.88 208.468C128.853 208.537 128.812 208.592 128.745 208.634L127.437 209.406C127.06 209.627 126.615 209.627 126.238 209.406L125.442 208.937C125.334 208.868 125.281 208.772 125.267 208.661V208.026L126.197 207.875Z",
    fill: "url(#paint212_linear_1136_96404)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M126.254 208.793L125.458 208.324C125.216 208.186 125.216 207.827 125.458 207.689L126.766 206.93C127.103 206.737 127.521 206.737 127.858 206.93L128.761 207.454C128.977 207.579 128.977 207.896 128.761 208.02L127.453 208.793C127.089 209.014 126.631 209.014 126.254 208.793Z",
    fill: "url(#paint213_linear_1136_96404)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M122.72 209.96L123.286 209.629C123.623 209.436 124.041 209.436 124.378 209.629L124.702 209.822L125.43 209.712V210.54L125.403 210.554C125.376 210.623 125.335 210.678 125.268 210.719L123.96 211.478C123.583 211.699 123.138 211.699 122.761 211.478L121.965 211.009C121.857 210.94 121.804 210.844 121.79 210.733V210.098L122.72 209.96Z",
    fill: "url(#paint214_linear_1136_96404)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M122.775 210.871L121.979 210.402C121.737 210.264 121.737 209.905 121.979 209.767L123.287 209.008C123.624 208.815 124.042 208.815 124.379 209.008L125.282 209.533C125.498 209.657 125.498 209.974 125.282 210.098L123.974 210.871C123.597 211.092 123.139 211.092 122.775 210.871Z",
    fill: "url(#paint215_linear_1136_96404)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M119.23 212.046L119.796 211.715C120.133 211.522 120.551 211.522 120.888 211.715L121.212 211.908L121.94 211.798V212.626L121.913 212.64C121.886 212.709 121.845 212.764 121.778 212.805L120.47 213.578C120.093 213.799 119.648 213.799 119.27 213.578L118.475 213.109C118.367 213.04 118.313 212.943 118.3 212.833V212.198L119.23 212.046Z",
    fill: "url(#paint216_linear_1136_96404)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M119.283 212.957L118.488 212.488C118.245 212.35 118.245 211.991 118.488 211.853L119.796 211.094C120.133 210.901 120.551 210.901 120.888 211.094L121.791 211.619C122.007 211.743 122.007 212.06 121.791 212.184L120.483 212.957C120.119 213.178 119.661 213.178 119.283 212.957Z",
    fill: "url(#paint217_linear_1136_96404)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M115.752 214.132L116.319 213.801C116.656 213.608 117.073 213.608 117.41 213.801L117.734 213.994L118.462 213.884V214.712L118.435 214.726C118.408 214.795 118.368 214.85 118.3 214.891L116.993 215.65C116.615 215.871 116.17 215.871 115.793 215.65L114.998 215.181C114.89 215.112 114.836 215.016 114.822 214.905V214.27L115.752 214.132Z",
    fill: "url(#paint218_linear_1136_96404)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M115.806 215.043L115.011 214.574C114.768 214.436 114.768 214.077 115.011 213.939L116.318 213.18C116.655 212.987 117.073 212.987 117.41 213.18L118.313 213.704C118.529 213.829 118.529 214.146 118.313 214.27L117.006 215.043C116.628 215.25 116.17 215.264 115.806 215.043Z",
    fill: "url(#paint219_linear_1136_96404)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M112.261 216.21L112.827 215.879C113.164 215.686 113.582 215.686 113.919 215.879L114.242 216.072L114.97 215.962V216.79L114.943 216.804C114.916 216.873 114.876 216.928 114.808 216.969L113.501 217.742C113.123 217.963 112.679 217.963 112.301 217.742L111.506 217.273C111.398 217.204 111.344 217.107 111.331 216.997V216.362L112.261 216.21Z",
    fill: "url(#paint220_linear_1136_96404)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M112.314 217.121L111.519 216.652C111.276 216.514 111.276 216.155 111.519 216.017L112.826 215.258C113.163 215.065 113.581 215.065 113.918 215.258L114.822 215.783C115.037 215.907 115.037 216.224 114.822 216.348L113.514 217.121C113.137 217.328 112.692 217.342 112.314 217.121Z",
    fill: "url(#paint221_linear_1136_96404)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M108.782 218.293L109.348 217.961C109.685 217.768 110.103 217.768 110.44 217.961L110.764 218.155L111.492 218.044V218.872L111.465 218.886C111.438 218.955 111.397 219.01 111.33 219.052L110.022 219.811C109.645 220.031 109.2 220.031 108.823 219.811L108.027 219.341C107.919 219.272 107.866 219.176 107.852 219.065V218.431L108.782 218.293Z",
    fill: "url(#paint222_linear_1136_96404)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M108.823 219.203L108.028 218.734C107.785 218.596 107.785 218.237 108.028 218.099L109.335 217.34C109.672 217.147 110.09 217.147 110.427 217.34L111.33 217.865C111.546 217.989 111.546 218.306 111.33 218.43L110.023 219.203C109.659 219.41 109.2 219.41 108.823 219.203Z",
    fill: "url(#paint223_linear_1136_96404)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M147.119 195.388L151.163 192.973C151.5 192.78 151.918 192.78 152.255 192.973L152.578 193.166L153.306 193.056V193.884L153.279 193.898C153.252 193.967 153.212 194.022 153.145 194.063L148.346 196.906C147.968 197.127 147.523 197.127 147.146 196.906L146.351 196.437C146.243 196.368 146.189 196.271 146.175 196.161V195.526L147.119 195.388Z",
    fill: "url(#paint224_linear_1136_96404)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M147.159 196.283L146.364 195.814C146.121 195.676 146.121 195.317 146.364 195.179L151.163 192.336C151.5 192.143 151.918 192.143 152.255 192.336L153.158 192.861C153.373 192.985 153.373 193.302 153.158 193.426L148.359 196.269C147.995 196.504 147.536 196.504 147.159 196.283Z",
    fill: "url(#paint225_linear_1136_96404)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M153.604 195.015L154.17 194.684C154.507 194.491 154.925 194.491 155.262 194.684L155.586 194.877L156.314 194.767V195.595L156.287 195.609C156.26 195.678 156.219 195.733 156.152 195.774L154.844 196.533C154.467 196.754 154.022 196.754 153.644 196.533L152.849 196.064C152.741 195.995 152.687 195.898 152.674 195.788V195.153L153.604 195.015Z",
    fill: "url(#paint226_linear_1136_96404)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M153.646 195.926L152.851 195.457C152.608 195.319 152.608 194.96 152.851 194.822L154.159 194.063C154.496 193.87 154.913 193.87 155.25 194.063L156.154 194.587C156.369 194.711 156.369 195.029 156.154 195.153L154.846 195.926C154.482 196.133 154.024 196.133 153.646 195.926Z",
    fill: "url(#paint227_linear_1136_96404)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M150.114 197.097L150.68 196.766C151.017 196.573 151.435 196.573 151.772 196.766L152.095 196.959L152.823 196.849V197.677L152.796 197.691C152.769 197.76 152.729 197.815 152.662 197.856L151.354 198.629C150.976 198.85 150.532 198.85 150.154 198.629L149.359 198.16C149.251 198.091 149.197 197.994 149.184 197.884V197.249L150.114 197.097Z",
    fill: "url(#paint228_linear_1136_96404)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M150.168 198.012L149.372 197.543C149.13 197.405 149.13 197.046 149.372 196.908L150.68 196.149C151.017 195.956 151.435 195.956 151.772 196.149L152.675 196.673C152.891 196.797 152.891 197.115 152.675 197.239L151.368 198.012C150.99 198.219 150.532 198.219 150.168 198.012Z",
    fill: "url(#paint229_linear_1136_96404)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M146.636 199.187L147.202 198.856C147.539 198.663 147.957 198.663 148.294 198.856L148.617 199.049L149.345 198.939V199.767L149.318 199.78C149.291 199.849 149.251 199.905 149.184 199.946L147.876 200.705C147.498 200.926 147.054 200.926 146.676 200.705L145.881 200.236C145.773 200.167 145.719 200.07 145.706 199.96V199.325L146.636 199.187Z",
    fill: "url(#paint230_linear_1136_96404)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M146.677 200.094L145.881 199.625C145.639 199.487 145.639 199.128 145.881 198.99L147.189 198.231C147.526 198.038 147.944 198.038 148.281 198.231L149.184 198.755C149.4 198.879 149.4 199.197 149.184 199.321L147.876 200.094C147.512 200.301 147.054 200.301 146.677 200.094Z",
    fill: "url(#paint231_linear_1136_96404)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M125.715 211.687L126.281 211.356C126.618 211.163 127.036 211.163 127.373 211.356L127.697 211.549L128.425 211.439V212.267L128.398 212.28C128.371 212.349 128.33 212.405 128.263 212.446L126.955 213.219C126.578 213.44 126.133 213.44 125.756 213.219L124.96 212.75C124.853 212.681 124.799 212.584 124.785 212.474V211.839L125.715 211.687Z",
    fill: "url(#paint232_linear_1136_96404)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M125.768 212.578L124.973 212.109C124.73 211.971 124.73 211.612 124.973 211.474L126.28 210.715C126.617 210.522 127.035 210.522 127.372 210.715L128.275 211.24C128.491 211.364 128.491 211.681 128.275 211.805L126.968 212.578C126.604 212.799 126.145 212.799 125.768 212.578Z",
    fill: "url(#paint233_linear_1136_96404)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M122.237 213.769L122.803 213.438C123.14 213.245 123.558 213.245 123.895 213.438L124.219 213.631L124.947 213.521V214.349L124.92 214.362C124.893 214.431 124.852 214.487 124.785 214.528L123.477 215.301C123.1 215.522 122.655 215.522 122.278 215.301L121.482 214.832C121.375 214.763 121.321 214.666 121.307 214.556V213.921L122.237 213.769Z",
    fill: "url(#paint234_linear_1136_96404)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M122.292 214.668L121.496 214.199C121.254 214.061 121.254 213.702 121.496 213.564L122.804 212.805C123.141 212.612 123.559 212.612 123.896 212.805L124.799 213.329C125.015 213.454 125.015 213.771 124.799 213.895L123.492 214.668C123.114 214.889 122.656 214.889 122.292 214.668Z",
    fill: "url(#paint235_linear_1136_96404)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M118.745 215.835L119.311 215.504C119.648 215.311 120.066 215.311 120.403 215.504L120.726 215.697L121.454 215.587V216.415L121.427 216.429C121.4 216.498 121.36 216.553 121.292 216.594L119.985 217.367C119.607 217.588 119.162 217.588 118.785 217.367L117.99 216.898C117.882 216.829 117.828 216.732 117.814 216.622V215.987L118.745 215.835Z",
    fill: "url(#paint236_linear_1136_96404)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M118.798 216.746L118.003 216.277C117.76 216.139 117.76 215.78 118.003 215.642L119.31 214.883C119.647 214.69 120.065 214.69 120.402 214.883L121.305 215.408C121.521 215.532 121.521 215.849 121.305 215.973L119.998 216.746C119.634 216.967 119.176 216.967 118.798 216.746Z",
    fill: "url(#paint237_linear_1136_96404)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M115.267 217.925L115.833 217.594C116.17 217.401 116.588 217.401 116.925 217.594L117.249 217.787L117.977 217.677V218.505L117.95 218.519C117.923 218.588 117.882 218.643 117.815 218.684L116.507 219.457C116.13 219.678 115.685 219.678 115.308 219.457L114.512 218.988C114.404 218.919 114.35 218.822 114.337 218.712V218.077L115.267 217.925Z",
    fill: "url(#paint238_linear_1136_96404)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M115.308 218.836L114.513 218.367C114.27 218.229 114.27 217.87 114.513 217.732L115.82 216.973C116.157 216.78 116.575 216.78 116.912 216.973L117.815 217.497C118.031 217.622 118.031 217.939 117.815 218.063L116.508 218.836C116.144 219.057 115.685 219.057 115.308 218.836Z",
    fill: "url(#paint239_linear_1136_96404)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M111.777 220.007L112.343 219.676C112.68 219.483 113.098 219.483 113.435 219.676L113.758 219.869L114.486 219.759V220.587L114.459 220.601C114.432 220.67 114.392 220.725 114.325 220.766L113.017 221.539C112.64 221.76 112.195 221.76 111.817 221.539L111.022 221.07C110.914 221.001 110.86 220.904 110.847 220.794V220.159L111.777 220.007Z",
    fill: "url(#paint240_linear_1136_96404)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M111.83 220.918L111.035 220.449C110.792 220.311 110.792 219.952 111.035 219.814L112.343 219.055C112.68 218.862 113.098 218.862 113.435 219.055L114.338 219.579C114.553 219.704 114.553 220.021 114.338 220.145L113.03 220.918C112.653 221.139 112.208 221.139 111.83 220.918Z",
    fill: "url(#paint241_linear_1136_96404)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M143.147 201.265L143.713 200.934C144.05 200.741 144.468 200.741 144.805 200.934L145.128 201.127L145.856 201.017V201.845L145.829 201.859C145.802 201.928 145.762 201.983 145.695 202.024L130.489 211.091C130.111 211.312 129.666 211.312 129.289 211.091L128.494 210.622C128.386 210.553 128.332 210.456 128.318 210.346V209.711L143.147 201.265Z",
    fill: "url(#paint242_linear_1136_96404)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M129.302 210.468L128.507 209.999C128.264 209.861 128.264 209.502 128.507 209.364L143.713 200.297C144.05 200.104 144.467 200.104 144.804 200.297L145.708 200.822C145.923 200.946 145.923 201.263 145.708 201.387L130.502 210.454C130.124 210.675 129.666 210.689 129.302 210.468Z",
    fill: "url(#paint243_linear_1136_96404)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7645 215.398C94.778 215.398 96.3282 216.115 96.3687 216.088L149.036 183.644C150.034 183.051 150.668 181.947 150.668 180.76L152.096 131.508C152.096 130.624 149.94 129.852 149.279 129.852C149.036 129.852 148.807 129.921 148.592 130.045L96.8135 160.35C95.4116 161.178 94.5488 162.709 94.5488 164.365V215.191C94.5488 215.287 94.6567 215.398 94.7645 215.398Z",
    fill: "url(#paint244_linear_1136_96404)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3692 216.097C96.3827 216.097 96.4231 216.097 96.477 216.069L150.655 184.357C151.652 183.764 152.286 182.66 152.286 181.473V131.986C152.286 131.103 151.558 130.551 150.884 130.551C150.641 130.551 150.412 130.62 150.196 130.744L98.4317 161.035C97.0297 161.863 96.167 163.395 96.167 165.051V215.876C96.167 215.973 96.2748 216.097 96.3692 216.097Z",
    fill: "url(#paint245_linear_1136_96404)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M98.269 169.719V212.527L135.286 190.888L149.589 182.484C149.939 182.263 150.168 181.877 150.168 181.463V137.91L135.286 146.659L99.4823 167.58C98.7409 168.008 98.269 168.85 98.269 169.719Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M147.675 134.945C147.675 134.931 147.675 134.931 147.675 134.917C147.675 134.904 147.675 134.904 147.675 134.89C147.675 134.876 147.675 134.876 147.675 134.862C147.675 134.848 147.675 134.848 147.675 134.834C147.675 134.821 147.675 134.821 147.675 134.807C147.675 134.793 147.675 134.793 147.675 134.779C147.675 134.766 147.675 134.766 147.675 134.752C147.675 134.738 147.675 134.738 147.689 134.724C147.689 134.71 147.689 134.71 147.702 134.697C147.702 134.683 147.702 134.683 147.716 134.669C147.716 134.655 147.716 134.655 147.729 134.641C147.729 134.628 147.729 134.628 147.743 134.614C147.743 134.6 147.756 134.6 147.756 134.586C147.756 134.572 147.77 134.572 147.77 134.558C147.77 134.545 147.783 134.545 147.783 134.531C147.783 134.517 147.797 134.517 147.797 134.503C147.797 134.49 147.81 134.476 147.81 134.476C147.81 134.462 147.824 134.448 147.837 134.434C147.837 134.434 147.837 134.434 147.837 134.42C147.851 134.393 147.864 134.379 147.877 134.351C147.891 134.338 147.904 134.324 147.918 134.296C147.931 134.283 147.931 134.269 147.945 134.269C147.958 134.255 147.958 134.255 147.972 134.241C147.985 134.227 147.985 134.227 147.999 134.213C148.012 134.2 148.012 134.2 148.026 134.186L148.039 134.172C148.053 134.158 148.053 134.158 148.066 134.144C148.08 134.131 148.08 134.131 148.093 134.117C148.107 134.103 148.107 134.103 148.12 134.089C148.134 134.089 148.134 134.075 148.147 134.075C148.161 134.075 148.161 134.062 148.174 134.062C148.188 134.062 148.188 134.048 148.201 134.048C148.215 134.048 148.215 134.034 148.228 134.034C148.241 134.034 148.241 134.02 148.255 134.02C148.255 134.02 148.268 134.02 148.268 134.006C148.282 134.006 148.282 133.993 148.295 133.993C148.309 133.993 148.309 133.979 148.322 133.979C148.336 133.979 148.336 133.979 148.349 133.965C148.363 133.965 148.363 133.965 148.376 133.951C148.39 133.951 148.39 133.951 148.403 133.938C148.417 133.938 148.417 133.938 148.43 133.938C148.444 133.938 148.444 133.938 148.457 133.938C148.471 133.938 148.471 133.938 148.484 133.938H148.498C148.511 133.938 148.511 133.938 148.525 133.938C148.538 133.938 148.538 133.938 148.552 133.938C148.565 133.938 148.578 133.938 148.578 133.938C148.592 133.938 148.605 133.938 148.619 133.951C148.632 133.951 148.646 133.965 148.659 133.979L149.131 134.255C149.077 134.227 149.023 134.213 148.956 134.213C148.889 134.213 148.821 134.241 148.74 134.282C148.659 134.324 148.592 134.393 148.525 134.462C148.457 134.531 148.403 134.614 148.349 134.697C148.295 134.779 148.255 134.876 148.228 134.972C148.201 135.069 148.188 135.152 148.188 135.248C148.188 135.331 148.201 135.414 148.228 135.469C148.255 135.525 148.295 135.58 148.349 135.607L147.877 135.331C147.837 135.304 147.81 135.276 147.783 135.235C147.77 135.221 147.77 135.207 147.756 135.193C147.756 135.18 147.743 135.18 147.743 135.166C147.743 135.152 147.743 135.152 147.729 135.138C147.729 135.124 147.729 135.124 147.716 135.11C147.716 135.097 147.716 135.097 147.716 135.083C147.716 135.069 147.716 135.069 147.716 135.055C147.716 135.042 147.716 135.042 147.716 135.028C147.716 135.014 147.716 135.014 147.716 135C147.716 134.986 147.716 134.986 147.716 134.972C147.675 134.959 147.675 134.959 147.675 134.945Z",
    fill: "url(#paint246_linear_1136_96404)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M148.687 134.281C148.39 134.46 148.147 134.888 148.147 135.247C148.147 135.606 148.39 135.744 148.7 135.564C148.997 135.385 149.239 134.957 149.239 134.598C149.239 134.253 148.983 134.115 148.687 134.281Z",
    fill: "url(#paint247_linear_1136_96404)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M145.829 136.058C145.829 136.044 145.829 136.044 145.829 136.031C145.829 136.017 145.829 136.017 145.829 136.003C145.829 135.989 145.829 135.989 145.829 135.975C145.829 135.962 145.829 135.962 145.829 135.948C145.829 135.934 145.829 135.934 145.829 135.92C145.829 135.906 145.829 135.906 145.829 135.893C145.829 135.879 145.829 135.879 145.829 135.865C145.829 135.851 145.829 135.851 145.842 135.837C145.842 135.824 145.842 135.824 145.856 135.81C145.856 135.796 145.856 135.796 145.869 135.782C145.869 135.768 145.869 135.768 145.883 135.755C145.883 135.741 145.883 135.741 145.896 135.727C145.896 135.713 145.909 135.713 145.909 135.699C145.909 135.686 145.923 135.686 145.923 135.672C145.923 135.658 145.936 135.658 145.936 135.644C145.936 135.63 145.95 135.63 145.95 135.617C145.95 135.603 145.963 135.589 145.963 135.589C145.963 135.575 145.977 135.561 145.99 135.548C145.99 135.548 145.99 135.548 145.99 135.534C146.004 135.506 146.017 135.492 146.031 135.465C146.044 135.451 146.058 135.437 146.071 135.41C146.085 135.396 146.085 135.382 146.098 135.382C146.112 135.368 146.112 135.368 146.125 135.354C146.139 135.341 146.139 135.341 146.152 135.327C146.166 135.313 146.166 135.313 146.179 135.299L146.193 135.285C146.206 135.272 146.206 135.272 146.22 135.258C146.233 135.244 146.233 135.244 146.247 135.23C146.26 135.216 146.26 135.216 146.273 135.203C146.287 135.189 146.287 135.189 146.3 135.189C146.314 135.189 146.314 135.175 146.327 135.175C146.341 135.175 146.341 135.161 146.354 135.161C146.368 135.161 146.368 135.147 146.381 135.147C146.395 135.147 146.395 135.134 146.408 135.134C146.408 135.134 146.422 135.134 146.422 135.12C146.435 135.12 146.435 135.106 146.449 135.106C146.462 135.106 146.462 135.092 146.476 135.092C146.489 135.092 146.489 135.092 146.503 135.078C146.516 135.078 146.516 135.078 146.53 135.065C146.543 135.065 146.543 135.065 146.557 135.051C146.57 135.051 146.57 135.051 146.584 135.051C146.597 135.051 146.597 135.051 146.61 135.051C146.624 135.051 146.624 135.051 146.637 135.051H146.651C146.664 135.051 146.664 135.051 146.678 135.051C146.691 135.051 146.691 135.051 146.705 135.051C146.718 135.051 146.732 135.051 146.732 135.051C146.745 135.051 146.759 135.051 146.772 135.065C146.786 135.065 146.799 135.078 146.813 135.092L147.284 135.368C147.231 135.341 147.177 135.327 147.109 135.327C147.042 135.327 146.974 135.354 146.894 135.396C146.813 135.437 146.745 135.506 146.678 135.575C146.61 135.644 146.557 135.727 146.503 135.81C146.449 135.893 146.408 135.989 146.381 136.086C146.354 136.182 146.341 136.265 146.341 136.362C146.341 136.445 146.354 136.527 146.381 136.583C146.408 136.638 146.449 136.693 146.503 136.721L146.031 136.445C145.99 136.417 145.963 136.389 145.936 136.348C145.923 136.334 145.923 136.32 145.909 136.307C145.909 136.293 145.896 136.293 145.896 136.279C145.896 136.265 145.896 136.265 145.883 136.251C145.883 136.238 145.883 136.238 145.869 136.224C145.869 136.21 145.869 136.21 145.869 136.196C145.869 136.182 145.869 136.182 145.869 136.169C145.869 136.155 145.869 136.155 145.869 136.141C145.869 136.127 145.869 136.127 145.869 136.113C145.869 136.1 145.869 136.1 145.869 136.086C145.829 136.086 145.829 136.072 145.829 136.058Z",
    fill: "url(#paint248_linear_1136_96404)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M146.825 135.41C146.528 135.59 146.286 136.018 146.286 136.376C146.286 136.735 146.528 136.873 146.838 136.694C147.135 136.514 147.378 136.087 147.378 135.728C147.378 135.369 147.135 135.231 146.825 135.41Z",
    fill: "url(#paint249_linear_1136_96404)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M143.967 137.199C143.967 137.185 143.967 137.185 143.967 137.171C143.967 137.157 143.967 137.157 143.967 137.144C143.967 137.13 143.967 137.13 143.967 137.116C143.967 137.102 143.967 137.102 143.967 137.088C143.967 137.075 143.967 137.075 143.967 137.061C143.967 137.047 143.967 137.047 143.967 137.033C143.967 137.019 143.967 137.019 143.967 137.006C143.967 136.992 143.967 136.992 143.981 136.978C143.981 136.964 143.981 136.964 143.994 136.95C143.994 136.937 143.994 136.937 144.008 136.923C144.008 136.909 144.008 136.909 144.021 136.895C144.021 136.881 144.021 136.881 144.035 136.868C144.035 136.854 144.048 136.854 144.048 136.84C144.048 136.826 144.062 136.826 144.062 136.812C144.062 136.799 144.075 136.799 144.075 136.785C144.075 136.771 144.089 136.771 144.089 136.757C144.089 136.743 144.102 136.73 144.102 136.73C144.102 136.716 144.116 136.702 144.129 136.688C144.129 136.688 144.129 136.688 144.129 136.674C144.143 136.647 144.156 136.633 144.169 136.605C144.183 136.592 144.196 136.578 144.21 136.55C144.223 136.536 144.223 136.523 144.237 136.523C144.25 136.509 144.25 136.509 144.264 136.495C144.277 136.481 144.277 136.481 144.291 136.467C144.304 136.454 144.304 136.454 144.318 136.44L144.331 136.426C144.345 136.412 144.345 136.412 144.358 136.398C144.372 136.385 144.372 136.385 144.385 136.371C144.399 136.357 144.399 136.357 144.412 136.343C144.426 136.343 144.426 136.329 144.439 136.329C144.453 136.329 144.453 136.316 144.466 136.316C144.48 136.316 144.48 136.302 144.493 136.302C144.507 136.302 144.506 136.288 144.52 136.288C144.533 136.288 144.533 136.274 144.547 136.274C144.547 136.274 144.56 136.274 144.56 136.26C144.574 136.26 144.574 136.247 144.587 136.247C144.601 136.247 144.601 136.233 144.614 136.233C144.628 136.233 144.628 136.233 144.641 136.219C144.655 136.219 144.655 136.219 144.668 136.205C144.682 136.205 144.682 136.205 144.695 136.191C144.709 136.191 144.709 136.191 144.722 136.191C144.736 136.191 144.736 136.191 144.749 136.191C144.763 136.191 144.763 136.191 144.776 136.191H144.79C144.803 136.191 144.803 136.191 144.817 136.191C144.83 136.191 144.83 136.191 144.844 136.191C144.857 136.191 144.87 136.191 144.87 136.191C144.884 136.191 144.897 136.191 144.911 136.205C144.924 136.205 144.938 136.219 144.951 136.233L145.423 136.509C145.369 136.481 145.315 136.467 145.248 136.467C145.181 136.467 145.113 136.495 145.032 136.536C144.951 136.578 144.884 136.647 144.817 136.716C144.749 136.785 144.695 136.868 144.641 136.95C144.587 137.033 144.547 137.13 144.52 137.226C144.493 137.323 144.48 137.406 144.48 137.502C144.48 137.585 144.493 137.668 144.52 137.723C144.547 137.778 144.587 137.834 144.641 137.861L144.169 137.585C144.129 137.558 144.102 137.53 144.075 137.489C144.062 137.475 144.062 137.461 144.048 137.447C144.048 137.433 144.035 137.433 144.035 137.42C144.035 137.406 144.035 137.406 144.021 137.392C144.021 137.378 144.021 137.378 144.008 137.364C144.008 137.351 144.008 137.351 144.008 137.337C144.008 137.323 144.008 137.323 144.008 137.309C144.008 137.295 144.008 137.295 144.008 137.282C144.008 137.268 144.008 137.268 144.008 137.254C144.008 137.24 144.008 137.24 144.008 137.226C143.967 137.213 143.967 137.199 143.967 137.199Z",
    fill: "url(#paint250_linear_1136_96404)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M144.978 136.543C144.681 136.723 144.438 137.15 144.438 137.509C144.438 137.868 144.681 138.006 144.991 137.827C145.288 137.647 145.53 137.219 145.53 136.861C145.517 136.502 145.274 136.364 144.978 136.543Z",
    fill: "url(#paint251_linear_1136_96404)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M115.657 168.401L103.997 175.274C103.66 175.467 103.376 175.356 103.376 175.011C103.376 174.666 103.646 174.225 103.997 174.018L115.657 167.145C115.994 166.952 116.277 167.063 116.277 167.408C116.264 167.753 115.994 168.194 115.657 168.401Z",
    fill: "url(#paint252_linear_1136_96404)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M129.92 159.975L118.26 166.848C117.923 167.041 117.64 166.931 117.64 166.586C117.64 166.241 117.909 165.799 118.26 165.592L129.92 158.72C130.257 158.526 130.54 158.637 130.54 158.982C130.54 159.327 130.271 159.782 129.92 159.975Z",
    fill: "url(#paint253_linear_1136_96404)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M119.944 169.245L106.207 177.345C105.87 177.539 105.587 177.428 105.587 177.083C105.587 176.738 105.857 176.297 106.207 176.09L119.944 167.989C120.281 167.796 120.564 167.906 120.564 168.251C120.564 168.596 120.281 169.052 119.944 169.245Z",
    fill: "url(#paint254_linear_1136_96404)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M129.61 163.553L122.438 167.776C122.101 167.969 121.818 167.859 121.818 167.514C121.818 167.169 122.088 166.727 122.438 166.52L129.61 162.298C129.947 162.104 130.23 162.215 130.23 162.56C130.217 162.905 129.947 163.346 129.61 163.553Z",
    fill: "url(#paint255_linear_1136_96404)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M142.537 155.925L132.077 162.093C131.74 162.286 131.457 162.176 131.457 161.831C131.457 161.486 131.726 161.044 132.077 160.837L142.537 154.669C142.874 154.476 143.157 154.586 143.157 154.931C143.157 155.276 142.874 155.718 142.537 155.925Z",
    fill: "url(#paint256_linear_1136_96404)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M117.195 174.253L108.892 179.152C108.555 179.345 108.271 179.235 108.271 178.89C108.271 178.545 108.541 178.103 108.892 177.896L117.195 172.997C117.532 172.804 117.816 172.914 117.816 173.259C117.802 173.604 117.532 174.046 117.195 174.253Z",
    fill: "url(#paint257_linear_1136_96404)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M130.149 166.608L119.675 172.791C119.338 172.984 119.055 172.873 119.055 172.528C119.055 172.183 119.324 171.742 119.675 171.535L130.149 165.352C130.486 165.159 130.769 165.27 130.769 165.615C130.756 165.96 130.486 166.415 130.149 166.608Z",
    fill: "url(#paint258_linear_1136_96404)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M142.821 159.139L132.629 165.156C132.292 165.349 132.009 165.239 132.009 164.894C132.009 164.549 132.279 164.107 132.629 163.9L142.821 157.884C143.158 157.69 143.441 157.801 143.441 158.146C143.441 158.491 143.158 158.932 142.821 159.139Z",
    fill: "url(#paint259_linear_1136_96404)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M115.927 178.362L107.623 183.261C107.286 183.454 107.003 183.344 107.003 182.999C107.003 182.654 107.273 182.212 107.623 182.005L115.927 177.106C116.264 176.913 116.547 177.023 116.547 177.368C116.547 177.727 116.264 178.169 115.927 178.362Z",
    fill: "url(#paint260_linear_1136_96404)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M128.881 170.729L118.407 176.912C118.07 177.105 117.787 176.994 117.787 176.649C117.787 176.304 118.056 175.863 118.407 175.656L128.881 169.473C129.218 169.28 129.501 169.391 129.501 169.736C129.501 170.081 129.231 170.522 128.881 170.729Z",
    fill: "url(#paint261_linear_1136_96404)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M138.115 165.284L131.362 169.258C131.025 169.452 130.742 169.341 130.742 168.996C130.742 168.651 131.011 168.21 131.362 168.003L138.115 164.028C138.452 163.835 138.736 163.945 138.736 164.29C138.736 164.649 138.452 165.091 138.115 165.284Z",
    fill: "url(#paint262_linear_1136_96404)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M115.657 182.339L103.997 189.211C103.66 189.404 103.376 189.294 103.376 188.949C103.376 188.604 103.646 188.162 103.997 187.955L115.657 181.083C115.994 180.89 116.277 181 116.277 181.345C116.264 181.69 115.994 182.132 115.657 182.339Z",
    fill: "url(#paint263_linear_1136_96404)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M129.92 173.921L118.26 180.793C117.923 180.986 117.64 180.876 117.64 180.531C117.64 180.186 117.909 179.744 118.26 179.537L129.92 172.665C130.257 172.472 130.54 172.582 130.54 172.927C130.54 173.272 130.271 173.727 129.92 173.921Z",
    fill: "url(#paint264_linear_1136_96404)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M119.944 183.178L106.207 191.279C105.87 191.472 105.587 191.362 105.587 191.017C105.587 190.672 105.857 190.23 106.207 190.023L119.944 181.923C120.281 181.729 120.564 181.84 120.564 182.185C120.564 182.53 120.281 182.971 119.944 183.178Z",
    fill: "url(#paint265_linear_1136_96404)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M129.61 177.479L122.438 181.702C122.101 181.895 121.818 181.785 121.818 181.44C121.818 181.095 122.088 180.653 122.438 180.446L129.61 176.223C129.947 176.03 130.23 176.141 130.23 176.486C130.217 176.844 129.947 177.286 129.61 177.479Z",
    fill: "url(#paint266_linear_1136_96404)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M142.537 169.866L132.077 176.035C131.74 176.228 131.457 176.117 131.457 175.772C131.457 175.427 131.726 174.986 132.077 174.779L142.537 168.61C142.874 168.417 143.157 168.527 143.157 168.872C143.157 169.217 142.874 169.659 142.537 169.866Z",
    fill: "url(#paint267_linear_1136_96404)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M117.195 188.182L108.892 193.081C108.555 193.275 108.271 193.164 108.271 192.819C108.271 192.474 108.541 192.033 108.892 191.826L117.195 186.927C117.532 186.733 117.816 186.844 117.816 187.189C117.802 187.534 117.532 187.975 117.195 188.182Z",
    fill: "url(#paint268_linear_1136_96404)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M130.149 180.55L119.675 186.732C119.338 186.925 119.055 186.815 119.055 186.47C119.055 186.125 119.324 185.683 119.675 185.476L130.149 179.294C130.486 179.101 130.769 179.211 130.769 179.556C130.756 179.901 130.486 180.356 130.149 180.55Z",
    fill: "url(#paint269_linear_1136_96404)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M142.821 173.065L132.629 179.082C132.292 179.275 132.009 179.165 132.009 178.82C132.009 178.475 132.279 178.033 132.629 177.826L142.821 171.809C143.158 171.616 143.441 171.727 143.441 172.072C143.441 172.43 143.158 172.872 142.821 173.065Z",
    fill: "url(#paint270_linear_1136_96404)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M115.927 192.303L107.623 197.202C107.286 197.396 107.003 197.285 107.003 196.94C107.003 196.595 107.273 196.154 107.623 195.947L115.927 191.048C116.264 190.854 116.547 190.965 116.547 191.31C116.547 191.655 116.264 192.11 115.927 192.303Z",
    fill: "url(#paint271_linear_1136_96404)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M128.881 184.655L118.407 190.837C118.07 191.031 117.787 190.92 117.787 190.575C117.787 190.23 118.056 189.789 118.407 189.582L128.881 183.399C129.218 183.206 129.501 183.316 129.501 183.661C129.501 184.02 129.231 184.462 128.881 184.655Z",
    fill: "url(#paint272_linear_1136_96404)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M138.115 179.214L131.362 183.188C131.025 183.381 130.742 183.271 130.742 182.926C130.742 182.581 131.011 182.139 131.362 181.932L138.115 177.958C138.452 177.765 138.736 177.875 138.736 178.22C138.736 178.579 138.452 179.02 138.115 179.214Z",
    fill: "url(#paint273_linear_1136_96404)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M261.653 283.252L197.325 245.758C195.343 244.599 192.917 244.599 190.935 245.744L159.634 263.96L155.36 263.284V268.155L155.495 268.224C155.643 268.611 155.9 268.969 156.29 269.204L224.959 309.252C227.13 310.521 229.785 310.535 231.969 309.265L265.967 289.476C266.6 289.104 266.924 288.483 266.991 287.834L267.018 287.82V284.108L261.653 283.252Z",
    fill: "#303E97"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M261.653 283.182L197.325 245.688C195.343 244.528 192.917 244.528 190.935 245.674L159.634 263.89L155.36 263.214V268.085L155.495 268.154C155.643 268.54 155.9 268.899 156.29 269.134L224.959 309.181C227.13 310.451 229.785 310.465 231.969 309.195L265.967 289.406C266.6 289.033 266.924 288.412 266.991 287.764L267.018 287.75V284.038L261.653 283.182Z",
    fill: "url(#paint274_linear_1136_96404)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M231.983 305.523L265.98 285.734C267.369 284.92 267.382 282.877 265.994 282.063L197.325 242.016C195.343 240.856 192.917 240.856 190.935 242.002L156.304 262.15C155.051 262.881 155.051 264.717 156.291 265.462L224.96 305.509C227.144 306.779 229.813 306.793 231.983 305.523Z",
    fill: "url(#paint275_linear_1136_96404)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M228.492 304.625C227.575 304.625 226.672 304.377 225.877 303.907L157.194 263.86L191.825 243.601C192.526 243.201 193.322 242.98 194.117 242.98C194.926 242.98 195.721 243.201 196.422 243.615L265.091 283.663C265.132 283.677 265.226 283.746 265.226 283.897C265.226 284.063 265.118 284.118 265.091 284.132L231.094 303.921C230.298 304.377 229.395 304.625 228.492 304.625Z",
    fill: "url(#paint276_linear_1136_96404)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M265.979 285.525L231.982 305.314C229.811 306.584 227.142 306.57 224.972 305.3L156.303 265.253C155.71 264.908 155.413 264.314 155.386 263.707C155.346 264.383 155.656 265.073 156.303 265.46L224.972 305.507C227.142 306.777 229.798 306.791 231.982 305.521L265.979 285.732C266.707 285.304 267.044 284.545 267.017 283.786C266.977 284.476 266.64 285.138 265.979 285.525Z",
    fill: "url(#paint277_linear_1136_96404)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M247.216 297.936L251.004 295.742V297.026L247.216 299.234V297.936Z",
    fill: "url(#paint278_linear_1136_96404)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.139 307.017L233.735 307.251V305.416L234.139 305.195V307.017Z",
    fill: "url(#paint279_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.138 306.449L234.747 306.669V304.834L235.138 304.613V306.449Z",
    fill: "url(#paint280_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.148 305.868L235.743 306.103V304.268L236.148 304.047V305.868Z",
    fill: "url(#paint281_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.145 305.3L236.754 305.521V303.686L237.145 303.465V305.3Z",
    fill: "url(#paint282_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.156 304.718L237.751 304.939V303.117L238.156 302.883V304.718Z",
    fill: "url(#paint283_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.154 304.156L238.763 304.377V302.541L239.154 302.32V304.156Z",
    fill: "url(#paint284_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.165 303.582L239.774 303.802V301.981L240.165 301.746V303.582Z",
    fill: "url(#paint285_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.176 303.001L240.771 303.236V301.401L241.176 301.18V303.001Z",
    fill: "url(#paint286_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.173 302.433L241.782 302.654V300.832L242.173 300.598V302.433Z",
    fill: "url(#paint287_linear_1136_96404)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.722 294.472L255.317 294.693V292.871L255.722 292.637V294.472Z",
    fill: "url(#paint288_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72 293.892L256.329 294.127V292.291L256.72 292.07V293.892Z",
    fill: "url(#paint289_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.73 293.328L257.326 293.548V291.727L257.73 291.492V293.328Z",
    fill: "url(#paint290_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.727 292.743L258.336 292.978V291.143L258.727 290.922V292.743Z",
    fill: "url(#paint291_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.738 292.175L259.334 292.396V290.574L259.738 290.34V292.175Z",
    fill: "url(#paint292_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.737 291.599L260.346 291.834V289.998L260.737 289.777V291.599Z",
    fill: "url(#paint293_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.748 291.038L261.343 291.259V289.438L261.748 289.203V291.038Z",
    fill: "url(#paint294_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.745 290.458L262.354 290.693V288.858L262.745 288.637V290.458Z",
    fill: "url(#paint295_linear_1136_96404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.757 289.89L263.366 290.111V288.289L263.757 288.055V289.89Z",
    fill: "url(#paint296_linear_1136_96404)"
  }))), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M257.177 130.457L257.19 155.545L264.321 159.81L264.294 134.721L257.177 130.457Z",
    fill: "url(#paint297_linear_1136_96404)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M264.296 134.722L264.323 159.81L277.628 151.93L277.615 126.828L264.296 134.722Z",
    fill: "url(#paint298_linear_1136_96404)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M257.177 130.458L264.294 134.722L277.613 126.829L270.482 122.578L257.177 130.458Z",
    fill: "url(#paint299_linear_1136_96404)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M265.818 152.459L275.349 146.884V130.973L265.818 136.548V152.459Z",
    fill: "url(#paint300_linear_1136_96404)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M272.666 132.546V145.407L275.348 146.884V130.973L272.666 132.546Z",
    fill: "#404982"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M272.666 145.402L265.818 149.253V152.454L275.349 146.879L272.666 145.402Z",
    fill: "#535FAC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M270.845 143.061L271.964 142.399V141.074L270.845 141.723V143.061Z",
    fill: "url(#paint301_linear_1136_96404)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M268.973 144.159L270.092 143.51V142.172L268.973 142.834V144.159Z",
    fill: "url(#paint302_linear_1136_96404)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M267.099 145.28L268.218 144.618V143.293L267.099 143.942V145.28Z",
    fill: "url(#paint303_linear_1136_96404)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M270.845 140.518L271.964 139.856V138.531L270.845 139.18V140.518Z",
    fill: "url(#paint304_linear_1136_96404)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M268.973 141.624L270.092 140.975V139.637L268.973 140.299V141.624Z",
    fill: "url(#paint305_linear_1136_96404)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M267.099 142.741L268.218 142.079V140.754L267.099 141.402V142.741Z",
    fill: "url(#paint306_linear_1136_96404)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M270.845 137.979L271.964 137.317V135.992L270.845 136.641V137.979Z",
    fill: "#1D3CFF"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M268.973 139.083L270.092 138.434V137.109L268.973 137.758V139.083Z",
    fill: "url(#paint307_linear_1136_96404)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M267.099 140.202L268.218 139.553V138.215L267.099 138.877V140.202Z",
    fill: "#435CF9"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M263.473 308.199C261.896 308.199 260.318 307.743 258.917 306.846L248.402 300.084L249.265 298.677L259.779 305.439C262.004 306.86 264.78 306.901 267.032 305.535L281.604 296.676C283.518 295.503 285.918 295.489 287.859 296.607L298.293 302.665C300.328 303.852 302.863 303.838 304.885 302.651L345.757 278.68C346.593 278.197 347.078 277.314 347.078 276.334C347.065 275.355 346.566 274.485 345.717 274.002L293.669 244.843C292.038 243.932 291.054 242.248 291.027 240.344C291 238.44 291.957 236.728 293.561 235.776L334.811 211.281C335.431 210.922 335.795 210.26 335.795 209.529C335.795 208.797 335.431 208.149 334.811 207.776L272.977 170.82C271.224 169.771 270.146 167.839 270.146 165.769V149.43H271.763V165.769C271.763 167.259 272.545 168.639 273.799 169.384L335.633 206.341C336.752 207.003 337.413 208.204 337.413 209.529C337.413 210.853 336.739 212.04 335.62 212.703L294.37 237.198C293.278 237.846 292.631 239.019 292.644 240.316C292.658 241.614 293.332 242.759 294.451 243.38L346.498 272.539C347.86 273.298 348.682 274.706 348.696 276.307C348.709 277.894 347.914 279.315 346.566 280.116L305.693 304.086C303.173 305.563 300.032 305.577 297.497 304.1L287.064 298.042C285.621 297.214 283.842 297.228 282.426 298.097L267.854 306.957C266.492 307.785 264.983 308.199 263.473 308.199Z",
    fill: "url(#paint308_linear_1136_96404)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M170.807 305.347C169.392 305.347 167.963 304.961 166.709 304.202L140.773 288.456C139.303 287.559 137.47 287.559 136.001 288.428L125.055 294.901C122.844 296.212 120.107 296.212 117.897 294.914L59.2301 260.47C58.0304 259.766 57.3159 258.51 57.3024 257.089C57.289 255.681 58.0034 254.411 59.1897 253.694L101.451 228.191L102.273 229.613L60.012 255.115C59.3245 255.529 58.9201 256.261 58.9201 257.075C58.9201 257.889 59.338 258.62 60.0255 259.021L118.692 293.465C120.404 294.473 122.534 294.473 124.246 293.452L135.192 286.979C137.174 285.806 139.627 285.82 141.609 287.021L167.545 302.767C169.473 303.94 171.885 303.981 173.854 302.891L194.937 291.188L195.705 292.651L174.622 304.354C173.436 305.016 172.115 305.347 170.807 305.347Z",
    fill: "url(#paint309_linear_1136_96404)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M173.516 252.595L163.568 246.371C162.408 245.653 161.734 244.384 161.748 243.004C161.761 241.624 162.476 240.382 163.649 239.692L173.988 233.606C174.554 233.275 174.891 232.681 174.905 232.019C174.918 231.357 174.581 230.749 174.028 230.404L154.064 217.915L154.913 216.508L174.878 228.997C175.929 229.645 176.536 230.791 176.522 232.047C176.509 233.302 175.862 234.42 174.797 235.055L164.457 241.141C163.783 241.541 163.379 242.245 163.365 243.045C163.352 243.846 163.743 244.563 164.403 244.977L174.352 251.201L173.516 252.595Z",
    fill: "url(#paint310_linear_1136_96404)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M225.794 142.147C247.334 142.147 264.794 124.429 264.794 102.574C264.794 80.7177 247.334 63 225.794 63C204.255 63 186.794 80.7177 186.794 102.574C186.794 124.429 204.255 142.147 225.794 142.147Z",
    fill: "url(#paint311_linear_1136_96404)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M230.389 102.576L241.881 90.9153C243.152 89.6259 243.152 87.5417 241.881 86.2522C240.611 84.9628 238.557 84.9628 237.286 86.2522L225.794 97.9132L214.302 86.2522C213.031 84.9628 210.977 84.9628 209.706 86.2522C208.436 87.5417 208.436 89.6259 209.706 90.9153L221.198 102.576L209.706 114.237C208.436 115.527 208.436 117.611 209.706 118.9C210.34 119.543 211.172 119.867 212.004 119.867C212.836 119.867 213.668 119.543 214.302 118.9L225.794 107.239L237.286 118.9C237.92 119.543 238.752 119.867 239.584 119.867C240.416 119.867 241.248 119.543 241.881 118.9C243.152 117.611 243.152 115.527 241.881 114.237L230.389 102.576Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1136_96404",
    x1: 247.414,
    y1: 160.586,
    x2: 284.026,
    y2: 226.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1136_96404",
    x1: 191.292,
    y1: 235.463,
    x2: 191.292,
    y2: 165.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1136_96404",
    x1: 213.883,
    y1: 188.748,
    x2: 233.46,
    y2: 118.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1136_96404",
    x1: 214.716,
    y1: 185.609,
    x2: 229.124,
    y2: 133.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1136_96404",
    x1: 192.681,
    y1: 170.115,
    x2: 189.333,
    y2: 208.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1136_96404",
    x1: 194.476,
    y1: 170.907,
    x2: 194.687,
    y2: 191.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1136_96404",
    x1: 184.83,
    y1: 170.585,
    x2: 184.279,
    y2: 179.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1136_96404",
    x1: 183.235,
    y1: 177.315,
    x2: 183.172,
    y2: 178.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1136_96404",
    x1: 184.953,
    y1: 178.338,
    x2: 184.89,
    y2: 179.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1136_96404",
    x1: 186.669,
    y1: 179.361,
    x2: 186.607,
    y2: 180.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1136_96404",
    x1: 183.235,
    y1: 174.981,
    x2: 183.172,
    y2: 176.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1136_96404",
    x1: 184.953,
    y1: 176.004,
    x2: 184.89,
    y2: 177.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1136_96404",
    x1: 186.669,
    y1: 177.024,
    x2: 186.607,
    y2: 178.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1136_96404",
    x1: 183.235,
    y1: 172.655,
    x2: 183.172,
    y2: 173.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1136_96404",
    x1: 184.953,
    y1: 173.678,
    x2: 184.89,
    y2: 174.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1136_96404",
    x1: 186.669,
    y1: 174.697,
    x2: 186.607,
    y2: 176.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1136_96404",
    x1: 203.549,
    y1: 184.638,
    x2: 203.259,
    y2: 185.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1136_96404",
    x1: 208.944,
    y1: 187.91,
    x2: 208.654,
    y2: 188.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1136_96404",
    x1: 194.477,
    y1: 186.835,
    x2: 194.688,
    y2: 207.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1136_96404",
    x1: 184.829,
    y1: 186.517,
    x2: 184.278,
    y2: 195.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1136_96404",
    x1: 183.234,
    y1: 193.243,
    x2: 183.171,
    y2: 194.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1136_96404",
    x1: 184.953,
    y1: 194.262,
    x2: 184.89,
    y2: 195.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1136_96404",
    x1: 186.67,
    y1: 195.282,
    x2: 186.607,
    y2: 196.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1136_96404",
    x1: 183.234,
    y1: 190.909,
    x2: 183.171,
    y2: 192.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1136_96404",
    x1: 184.953,
    y1: 191.932,
    x2: 184.89,
    y2: 193.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1136_96404",
    x1: 186.67,
    y1: 192.952,
    x2: 186.607,
    y2: 194.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1136_96404",
    x1: 183.234,
    y1: 188.583,
    x2: 183.171,
    y2: 189.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1136_96404",
    x1: 184.953,
    y1: 189.602,
    x2: 184.89,
    y2: 190.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1136_96404",
    x1: 186.67,
    y1: 190.622,
    x2: 186.607,
    y2: 191.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1136_96404",
    x1: 203.551,
    y1: 200.562,
    x2: 203.261,
    y2: 201.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1136_96404",
    x1: 208.943,
    y1: 203.838,
    x2: 208.653,
    y2: 204.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1136_96404",
    x1: 254.763,
    y1: 171.007,
    x2: 284.672,
    y2: 225.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1136_96404",
    x1: 240.428,
    y1: 242.634,
    x2: 240.125,
    y2: 203.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9097C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1136_96404",
    x1: 258.879,
    y1: 195.639,
    x2: 269.494,
    y2: 157.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1136_96404",
    x1: 258.933,
    y1: 195.433,
    x2: 269.213,
    y2: 158.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1136_96404",
    x1: 260.452,
    y1: 181.79,
    x2: 278.394,
    y2: 214.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1136_96404",
    x1: 271.81,
    y1: 185.201,
    x2: 270.367,
    y2: 183.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1136_96404",
    x1: 270.454,
    y1: 187.842,
    x2: 269.393,
    y2: 186.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1136_96404",
    x1: 263.414,
    y1: 191.927,
    x2: 262.354,
    y2: 190.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1136_96404",
    x1: 268.047,
    y1: 191.985,
    x2: 266.736,
    y2: 190.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1136_96404",
    x1: 258.22,
    y1: 197.683,
    x2: 256.909,
    y2: 196.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1136_96404",
    x1: 269.57,
    y1: 193.317,
    x2: 268.394,
    y2: 191.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1136_96404",
    x1: 262.157,
    y1: 197.606,
    x2: 260.98,
    y2: 196.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1136_96404",
    x1: 272.576,
    y1: 193.987,
    x2: 271.385,
    y2: 192.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1136_96404",
    x1: 264.61,
    y1: 198.608,
    x2: 263.419,
    y2: 197.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1136_96404",
    x1: 258.039,
    y1: 201.889,
    x2: 257.223,
    y2: 200.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1136_96404",
    x1: 269.924,
    y1: 197.967,
    x2: 268.701,
    y2: 196.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1136_96404",
    x1: 261.706,
    y1: 202.726,
    x2: 260.483,
    y2: 201.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1136_96404",
    x1: 270.553,
    y1: 199.769,
    x2: 269.491,
    y2: 198.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1136_96404",
    x1: 271.796,
    y1: 203.655,
    x2: 270.733,
    y2: 202.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1136_96404",
    x1: 264.8,
    y1: 207.77,
    x2: 263.738,
    y2: 206.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1136_96404",
    x1: 273.064,
    y1: 205.888,
    x2: 272.001,
    y2: 204.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1136_96404",
    x1: 262.896,
    y1: 211.921,
    x2: 261.834,
    y2: 210.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1136_96404",
    x1: 263.803,
    y1: 203.69,
    x2: 262.741,
    y2: 202.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1136_96404",
    x1: 271.52,
    y1: 202.143,
    x2: 270.078,
    y2: 200.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1136_96404",
    x1: 261.969,
    y1: 190.836,
    x2: 260.574,
    y2: 189.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1136_96404",
    x1: 246.109,
    y1: 187.375,
    x2: 249.287,
    y2: 187.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1136_96404",
    x1: 292.031,
    y1: 160.607,
    x2: 295.209,
    y2: 160.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1136_96404",
    x1: 246.109,
    y1: 234.966,
    x2: 249.287,
    y2: 234.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1136_96404",
    x1: 292.031,
    y1: 208.198,
    x2: 295.209,
    y2: 208.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1136_96404",
    x1: 247.413,
    y1: 83.31,
    x2: 284.025,
    y2: 149.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1136_96404",
    x1: 191.291,
    y1: 158.187,
    x2: 191.291,
    y2: 87.7951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1136_96404",
    x1: 213.882,
    y1: 111.467,
    x2: 233.459,
    y2: 41.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1136_96404",
    x1: 214.715,
    y1: 108.325,
    x2: 229.124,
    y2: 56.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1136_96404",
    x1: 256.146,
    y1: 69.5379,
    x2: 259.663,
    y2: 75.9014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1136_96404",
    x1: 200.777,
    y1: 86.493,
    x2: 200.777,
    y2: 62.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1136_96404",
    x1: 247.357,
    y1: 82.8868,
    x2: 197.75,
    y2: 6.2439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1136_96404",
    x1: 218.873,
    y1: 90.6591,
    x2: 229.811,
    y2: 51.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1136_96404",
    x1: 192.683,
    y1: 92.8392,
    x2: 189.334,
    y2: 130.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1136_96404",
    x1: 194.476,
    y1: 93.627,
    x2: 194.687,
    y2: 114.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1136_96404",
    x1: 184.83,
    y1: 93.3092,
    x2: 184.279,
    y2: 102.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1136_96404",
    x1: 183.234,
    y1: 100.037,
    x2: 183.171,
    y2: 101.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1136_96404",
    x1: 184.952,
    y1: 101.056,
    x2: 184.889,
    y2: 102.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1136_96404",
    x1: 186.669,
    y1: 102.076,
    x2: 186.606,
    y2: 103.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1136_96404",
    x1: 183.234,
    y1: 97.7012,
    x2: 183.171,
    y2: 99.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1136_96404",
    x1: 184.952,
    y1: 98.7244,
    x2: 184.889,
    y2: 100.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1136_96404",
    x1: 186.669,
    y1: 99.7436,
    x2: 186.606,
    y2: 101.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1136_96404",
    x1: 183.234,
    y1: 95.3751,
    x2: 183.171,
    y2: 96.6963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1136_96404",
    x1: 184.952,
    y1: 96.3943,
    x2: 184.889,
    y2: 97.7155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1136_96404",
    x1: 186.669,
    y1: 97.4135,
    x2: 186.606,
    y2: 98.7347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1136_96404",
    x1: 203.55,
    y1: 107.354,
    x2: 203.26,
    y2: 107.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1136_96404",
    x1: 208.942,
    y1: 110.628,
    x2: 208.652,
    y2: 111.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1136_96404",
    x1: 194.477,
    y1: 109.555,
    x2: 194.688,
    y2: 130.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1136_96404",
    x1: 184.829,
    y1: 109.237,
    x2: 184.278,
    y2: 118.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1136_96404",
    x1: 183.234,
    y1: 115.963,
    x2: 183.171,
    y2: 117.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1136_96404",
    x1: 184.953,
    y1: 116.982,
    x2: 184.89,
    y2: 118.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1136_96404",
    x1: 186.67,
    y1: 118.002,
    x2: 186.607,
    y2: 119.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1136_96404",
    x1: 183.234,
    y1: 113.629,
    x2: 183.171,
    y2: 114.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1136_96404",
    x1: 184.953,
    y1: 114.652,
    x2: 184.89,
    y2: 115.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1136_96404",
    x1: 186.67,
    y1: 115.672,
    x2: 186.607,
    y2: 116.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1136_96404",
    x1: 183.234,
    y1: 111.303,
    x2: 183.171,
    y2: 112.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1136_96404",
    x1: 184.953,
    y1: 112.322,
    x2: 184.89,
    y2: 113.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1136_96404",
    x1: 186.67,
    y1: 113.342,
    x2: 186.607,
    y2: 114.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1136_96404",
    x1: 203.551,
    y1: 123.282,
    x2: 203.261,
    y2: 123.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1136_96404",
    x1: 208.943,
    y1: 126.558,
    x2: 208.653,
    y2: 127.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1136_96404",
    x1: 88.4574,
    y1: 199.914,
    x2: 134.355,
    y2: 127.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1136_96404",
    x1: 143.794,
    y1: 168.33,
    x2: 78.9801,
    y2: 168.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1136_96404",
    x1: 142.339,
    y1: 168.224,
    x2: 78.9813,
    y2: 168.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1136_96404",
    x1: 141.925,
    y1: 168.333,
    x2: 80.8508,
    y2: 168.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1136_96404",
    x1: 97.6043,
    y1: 218.926,
    x2: 146.271,
    y2: 205.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1136_96404",
    x1: 179.951,
    y1: 206.944,
    x2: 82.9035,
    y2: 206.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1136_96404",
    x1: 179.945,
    y1: 217.431,
    x2: 82.9115,
    y2: 217.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1136_96404",
    x1: 159.336,
    y1: 204.148,
    x2: 92.8438,
    y2: 204.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1136_96404",
    x1: 157.093,
    y1: 213.349,
    x2: 129.677,
    y2: 213.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1136_96404",
    x1: 138.271,
    y1: 187.396,
    x2: 140.144,
    y2: 186.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1136_96404",
    x1: 141.324,
    y1: 186.431,
    x2: 137.681,
    y2: 186.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1136_96404",
    x1: 134.784,
    y1: 189.488,
    x2: 136.657,
    y2: 188.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1136_96404",
    x1: 137.838,
    y1: 188.512,
    x2: 134.196,
    y2: 188.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1136_96404",
    x1: 131.3,
    y1: 191.566,
    x2: 133.174,
    y2: 191.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1136_96404",
    x1: 134.353,
    y1: 190.597,
    x2: 130.71,
    y2: 190.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1136_96404",
    x1: 127.815,
    y1: 193.647,
    x2: 129.688,
    y2: 193.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1136_96404",
    x1: 130.868,
    y1: 192.686,
    x2: 127.226,
    y2: 192.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1136_96404",
    x1: 124.33,
    y1: 195.732,
    x2: 126.203,
    y2: 195.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1136_96404",
    x1: 127.383,
    y1: 194.765,
    x2: 123.74,
    y2: 194.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1136_96404",
    x1: 120.845,
    y1: 197.817,
    x2: 122.718,
    y2: 197.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1136_96404",
    x1: 123.897,
    y1: 196.85,
    x2: 120.255,
    y2: 196.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1136_96404",
    x1: 117.361,
    y1: 199.898,
    x2: 119.234,
    y2: 199.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1136_96404",
    x1: 120.412,
    y1: 198.927,
    x2: 116.77,
    y2: 198.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1136_96404",
    x1: 113.874,
    y1: 201.975,
    x2: 115.747,
    y2: 201.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1136_96404",
    x1: 116.926,
    y1: 201.012,
    x2: 113.284,
    y2: 201.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1136_96404",
    x1: 110.388,
    y1: 204.064,
    x2: 112.261,
    y2: 203.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1136_96404",
    x1: 113.441,
    y1: 203.093,
    x2: 109.798,
    y2: 203.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1136_96404",
    x1: 106.904,
    y1: 206.149,
    x2: 108.777,
    y2: 205.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1136_96404",
    x1: 109.957,
    y1: 205.179,
    x2: 106.314,
    y2: 205.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1136_96404",
    x1: 103.419,
    y1: 208.225,
    x2: 105.293,
    y2: 207.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1136_96404",
    x1: 106.473,
    y1: 207.256,
    x2: 102.83,
    y2: 207.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1136_96404",
    x1: 99.9331,
    y1: 210.31,
    x2: 101.806,
    y2: 209.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1136_96404",
    x1: 102.986,
    y1: 209.341,
    x2: 99.3431,
    y2: 209.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1136_96404",
    x1: 96.4494,
    y1: 212.395,
    x2: 98.3224,
    y2: 211.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1136_96404",
    x1: 99.5027,
    y1: 211.426,
    x2: 95.8602,
    y2: 211.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1136_96404",
    x1: 138.171,
    y1: 190.537,
    x2: 141.974,
    y2: 189.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1136_96404",
    x1: 144.321,
    y1: 189.19,
    x2: 137.193,
    y2: 189.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1136_96404",
    x1: 134.298,
    y1: 193.283,
    x2: 136.171,
    y2: 192.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1136_96404",
    x1: 137.351,
    y1: 192.315,
    x2: 133.708,
    y2: 192.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1136_96404",
    x1: 130.811,
    y1: 195.364,
    x2: 132.684,
    y2: 194.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1136_96404",
    x1: 133.866,
    y1: 194.396,
    x2: 130.223,
    y2: 194.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1136_96404",
    x1: 127.328,
    y1: 197.449,
    x2: 129.201,
    y2: 196.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1136_96404",
    x1: 130.381,
    y1: 196.485,
    x2: 126.738,
    y2: 196.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1136_96404",
    x1: 123.843,
    y1: 199.527,
    x2: 125.716,
    y2: 199.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1136_96404",
    x1: 126.896,
    y1: 198.558,
    x2: 123.253,
    y2: 198.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1136_96404",
    x1: 120.356,
    y1: 201.619,
    x2: 122.229,
    y2: 201.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1136_96404",
    x1: 123.409,
    y1: 200.651,
    x2: 119.766,
    y2: 200.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1136_96404",
    x1: 116.874,
    y1: 203.697,
    x2: 118.747,
    y2: 203.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1136_96404",
    x1: 119.927,
    y1: 202.726,
    x2: 116.284,
    y2: 202.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1136_96404",
    x1: 113.386,
    y1: 205.782,
    x2: 115.259,
    y2: 205.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1136_96404",
    x1: 116.438,
    y1: 204.811,
    x2: 112.796,
    y2: 204.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1136_96404",
    x1: 109.903,
    y1: 207.863,
    x2: 111.776,
    y2: 207.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1136_96404",
    x1: 112.956,
    y1: 206.892,
    x2: 109.313,
    y2: 206.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1136_96404",
    x1: 106.418,
    y1: 209.948,
    x2: 108.291,
    y2: 209.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1136_96404",
    x1: 109.472,
    y1: 208.977,
    x2: 105.829,
    y2: 208.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1136_96404",
    x1: 99.8335,
    y1: 213.453,
    x2: 103.637,
    y2: 212.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1136_96404",
    x1: 105.984,
    y1: 212.104,
    x2: 98.8565,
    y2: 212.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1136_96404",
    x1: 144.268,
    y1: 190.829,
    x2: 146.141,
    y2: 190.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1136_96404",
    x1: 147.322,
    y1: 189.858,
    x2: 143.679,
    y2: 189.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1136_96404",
    x1: 140.784,
    y1: 192.908,
    x2: 142.657,
    y2: 192.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1136_96404",
    x1: 143.835,
    y1: 191.943,
    x2: 140.193,
    y2: 191.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1136_96404",
    x1: 137.298,
    y1: 194.993,
    x2: 139.171,
    y2: 194.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1136_96404",
    x1: 140.351,
    y1: 194.024,
    x2: 136.709,
    y2: 194.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1136_96404",
    x1: 133.813,
    y1: 197.074,
    x2: 135.686,
    y2: 196.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1136_96404",
    x1: 136.865,
    y1: 196.105,
    x2: 133.223,
    y2: 196.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1136_96404",
    x1: 130.327,
    y1: 199.159,
    x2: 132.2,
    y2: 198.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1136_96404",
    x1: 133.38,
    y1: 198.195,
    x2: 129.738,
    y2: 198.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_1136_96404",
    x1: 126.843,
    y1: 201.237,
    x2: 128.716,
    y2: 200.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1136_96404",
    x1: 129.896,
    y1: 200.268,
    x2: 126.254,
    y2: 200.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1136_96404",
    x1: 123.358,
    y1: 203.322,
    x2: 125.231,
    y2: 202.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1136_96404",
    x1: 126.411,
    y1: 202.357,
    x2: 122.768,
    y2: 202.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1136_96404",
    x1: 119.871,
    y1: 205.407,
    x2: 121.744,
    y2: 204.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1136_96404",
    x1: 122.925,
    y1: 204.438,
    x2: 119.283,
    y2: 204.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1136_96404",
    x1: 116.386,
    y1: 207.488,
    x2: 118.259,
    y2: 206.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_1136_96404",
    x1: 119.439,
    y1: 206.519,
    x2: 115.796,
    y2: 206.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1136_96404",
    x1: 112.904,
    y1: 209.573,
    x2: 114.777,
    y2: 209.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1136_96404",
    x1: 115.956,
    y1: 208.604,
    x2: 112.314,
    y2: 208.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_1136_96404",
    x1: 109.415,
    y1: 211.662,
    x2: 111.288,
    y2: 211.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_1136_96404",
    x1: 112.469,
    y1: 210.691,
    x2: 108.826,
    y2: 210.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_1136_96404",
    x1: 105.931,
    y1: 213.739,
    x2: 107.805,
    y2: 213.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_1136_96404",
    x1: 108.983,
    y1: 212.768,
    x2: 105.341,
    y2: 212.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_1136_96404",
    x1: 102.446,
    y1: 215.816,
    x2: 104.319,
    y2: 215.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_1136_96404",
    x1: 105.5,
    y1: 214.846,
    x2: 101.857,
    y2: 214.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_1136_96404",
    x1: 147.269,
    y1: 192.543,
    x2: 149.142,
    y2: 192.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_1136_96404",
    x1: 150.322,
    y1: 191.572,
    x2: 146.679,
    y2: 191.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_1136_96404",
    x1: 143.786,
    y1: 194.628,
    x2: 145.659,
    y2: 194.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_1136_96404",
    x1: 146.838,
    y1: 193.657,
    x2: 143.196,
    y2: 193.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_1136_96404",
    x1: 140.299,
    y1: 196.705,
    x2: 142.173,
    y2: 196.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_1136_96404",
    x1: 143.353,
    y1: 195.738,
    x2: 139.71,
    y2: 195.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_1136_96404",
    x1: 136.816,
    y1: 198.79,
    x2: 138.689,
    y2: 198.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_1136_96404",
    x1: 139.867,
    y1: 197.819,
    x2: 136.224,
    y2: 197.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_1136_96404",
    x1: 133.329,
    y1: 200.873,
    x2: 135.202,
    y2: 200.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_1136_96404",
    x1: 136.383,
    y1: 199.908,
    x2: 132.74,
    y2: 199.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_1136_96404",
    x1: 129.845,
    y1: 202.95,
    x2: 131.717,
    y2: 202.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_1136_96404",
    x1: 132.897,
    y1: 201.982,
    x2: 129.255,
    y2: 201.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_1136_96404",
    x1: 126.358,
    y1: 205.039,
    x2: 128.231,
    y2: 204.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_1136_96404",
    x1: 129.41,
    y1: 204.071,
    x2: 125.768,
    y2: 204.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_1136_96404",
    x1: 122.875,
    y1: 207.124,
    x2: 124.748,
    y2: 206.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_1136_96404",
    x1: 125.928,
    y1: 206.156,
    x2: 122.285,
    y2: 206.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_1136_96404",
    x1: 119.389,
    y1: 209.206,
    x2: 121.262,
    y2: 208.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_1136_96404",
    x1: 122.441,
    y1: 208.237,
    x2: 118.798,
    y2: 208.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_1136_96404",
    x1: 115.904,
    y1: 211.279,
    x2: 117.777,
    y2: 210.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_1136_96404",
    x1: 118.957,
    y1: 210.31,
    x2: 115.314,
    y2: 210.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_1136_96404",
    x1: 112.419,
    y1: 213.372,
    x2: 114.292,
    y2: 212.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_1136_96404",
    x1: 115.472,
    y1: 212.403,
    x2: 111.829,
    y2: 212.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_1136_96404",
    x1: 105.836,
    y1: 216.869,
    x2: 109.639,
    y2: 215.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_1136_96404",
    x1: 111.986,
    y1: 215.521,
    x2: 104.859,
    y2: 215.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_1136_96404",
    x1: 143.297,
    y1: 198.423,
    x2: 145.17,
    y2: 197.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_1136_96404",
    x1: 146.35,
    y1: 197.448,
    x2: 142.708,
    y2: 197.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_1136_96404",
    x1: 139.814,
    y1: 200.5,
    x2: 141.687,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_1136_96404",
    x1: 142.867,
    y1: 199.537,
    x2: 139.225,
    y2: 199.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_1136_96404",
    x1: 136.328,
    y1: 202.589,
    x2: 138.201,
    y2: 202.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_1136_96404",
    x1: 139.379,
    y1: 201.614,
    x2: 135.736,
    y2: 201.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_1136_96404",
    x1: 132.843,
    y1: 204.67,
    x2: 134.716,
    y2: 204.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_1136_96404",
    x1: 135.896,
    y1: 203.699,
    x2: 132.253,
    y2: 203.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_1136_96404",
    x1: 129.356,
    y1: 206.747,
    x2: 131.229,
    y2: 206.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_1136_96404",
    x1: 132.412,
    y1: 205.78,
    x2: 128.769,
    y2: 205.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_1136_96404",
    x1: 125.87,
    y1: 208.83,
    x2: 127.744,
    y2: 208.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_1136_96404",
    x1: 128.926,
    y1: 207.869,
    x2: 125.283,
    y2: 207.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_1136_96404",
    x1: 122.386,
    y1: 210.915,
    x2: 124.259,
    y2: 210.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_1136_96404",
    x1: 125.44,
    y1: 209.947,
    x2: 121.797,
    y2: 209.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_1136_96404",
    x1: 118.902,
    y1: 213,
    x2: 120.775,
    y2: 212.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_1136_96404",
    x1: 121.955,
    y1: 212.032,
    x2: 118.312,
    y2: 212.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_1136_96404",
    x1: 115.418,
    y1: 215.085,
    x2: 117.291,
    y2: 214.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_1136_96404",
    x1: 118.47,
    y1: 214.117,
    x2: 114.828,
    y2: 214.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_1136_96404",
    x1: 111.932,
    y1: 217.163,
    x2: 113.805,
    y2: 216.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_1136_96404",
    x1: 114.985,
    y1: 216.194,
    x2: 111.342,
    y2: 216.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_1136_96404",
    x1: 108.447,
    y1: 219.244,
    x2: 110.32,
    y2: 218.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_1136_96404",
    x1: 111.5,
    y1: 218.275,
    x2: 107.857,
    y2: 218.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_1136_96404",
    x1: 147.169,
    y1: 195.672,
    x2: 150.972,
    y2: 194.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_1136_96404",
    x1: 153.319,
    y1: 194.323,
    x2: 146.191,
    y2: 194.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_1136_96404",
    x1: 153.267,
    y1: 195.966,
    x2: 155.14,
    y2: 195.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_1136_96404",
    x1: 156.322,
    y1: 194.998,
    x2: 152.679,
    y2: 194.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_1136_96404",
    x1: 149.783,
    y1: 198.047,
    x2: 151.656,
    y2: 197.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_1136_96404",
    x1: 152.836,
    y1: 197.083,
    x2: 149.194,
    y2: 197.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_1136_96404",
    x1: 146.298,
    y1: 200.136,
    x2: 148.171,
    y2: 199.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_1136_96404",
    x1: 149.351,
    y1: 199.164,
    x2: 145.709,
    y2: 199.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_1136_96404",
    x1: 125.388,
    y1: 212.631,
    x2: 127.261,
    y2: 212.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_1136_96404",
    x1: 128.44,
    y1: 211.657,
    x2: 124.797,
    y2: 211.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_1136_96404",
    x1: 121.903,
    y1: 214.712,
    x2: 123.776,
    y2: 214.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_1136_96404",
    x1: 124.956,
    y1: 213.745,
    x2: 121.314,
    y2: 213.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_1136_96404",
    x1: 118.417,
    y1: 216.791,
    x2: 120.29,
    y2: 216.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_1136_96404",
    x1: 121.469,
    y1: 215.823,
    x2: 117.827,
    y2: 215.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_1136_96404",
    x1: 114.932,
    y1: 218.88,
    x2: 116.805,
    y2: 218.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_1136_96404",
    x1: 117.985,
    y1: 217.912,
    x2: 114.343,
    y2: 217.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_1136_96404",
    x1: 111.448,
    y1: 220.961,
    x2: 113.321,
    y2: 220.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_1136_96404",
    x1: 114.501,
    y1: 219.993,
    x2: 110.858,
    y2: 219.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_1136_96404",
    x1: 130.464,
    y1: 207.872,
    x2: 140.034,
    y2: 205.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_1136_96404",
    x1: 145.868,
    y1: 205.392,
    x2: 128.327,
    y2: 205.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_1136_96404",
    x1: 105.499,
    y1: 207.907,
    x2: 138.626,
    y2: 142.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_1136_96404",
    x1: 152.273,
    y1: 173.325,
    x2: 96.1613,
    y2: 173.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_1136_96404",
    x1: 148.63,
    y1: 134.184,
    x2: 147.949,
    y2: 135.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_1136_96404",
    x1: 147.871,
    y1: 135.514,
    x2: 149.027,
    y2: 134.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_1136_96404",
    x1: 146.774,
    y1: 135.301,
    x2: 146.093,
    y2: 136.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_1136_96404",
    x1: 146.013,
    y1: 136.633,
    x2: 147.169,
    y2: 135.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_1136_96404",
    x1: 144.917,
    y1: 136.431,
    x2: 144.235,
    y2: 137.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_1136_96404",
    x1: 144.157,
    y1: 137.769,
    x2: 145.312,
    y2: 136.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_1136_96404",
    x1: 109.826,
    y1: 171.722,
    x2: 109.344,
    y2: 170.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_1136_96404",
    x1: 124.096,
    y1: 163.302,
    x2: 123.615,
    y2: 162.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_1136_96404",
    x1: 113.078,
    y1: 173.186,
    x2: 112.608,
    y2: 172.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_1136_96404",
    x1: 126.017,
    y1: 165.552,
    x2: 125.547,
    y2: 164.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_1136_96404",
    x1: 137.313,
    y1: 158.895,
    x2: 136.843,
    y2: 158.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_1136_96404",
    x1: 113.038,
    y1: 176.561,
    x2: 112.58,
    y2: 175.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_1136_96404",
    x1: 124.909,
    y1: 169.562,
    x2: 124.451,
    y2: 168.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_1136_96404",
    x1: 137.726,
    y1: 162.003,
    x2: 137.268,
    y2: 161.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_1136_96404",
    x1: 111.776,
    y1: 180.68,
    x2: 111.271,
    y2: 179.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_1136_96404",
    x1: 123.647,
    y1: 173.679,
    x2: 123.143,
    y2: 172.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_1136_96404",
    x1: 134.741,
    y1: 167.145,
    x2: 134.237,
    y2: 166.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_1136_96404",
    x1: 109.826,
    y1: 185.613,
    x2: 109.372,
    y2: 184.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_1136_96404",
    x1: 124.096,
    y1: 177.2,
    x2: 123.643,
    y2: 176.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_1136_96404",
    x1: 113.078,
    y1: 187.099,
    x2: 112.57,
    y2: 186.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_1136_96404",
    x1: 126.017,
    y1: 179.471,
    x2: 125.509,
    y2: 178.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_1136_96404",
    x1: 137.313,
    y1: 172.816,
    x2: 136.805,
    y2: 171.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_1136_96404",
    x1: 113.038,
    y1: 190.502,
    x2: 112.585,
    y2: 189.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_1136_96404",
    x1: 124.909,
    y1: 183.515,
    x2: 124.455,
    y2: 182.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_1136_96404",
    x1: 137.726,
    y1: 175.954,
    x2: 137.273,
    y2: 175.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_1136_96404",
    x1: 111.776,
    y1: 194.728,
    x2: 111.277,
    y2: 193.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_1136_96404",
    x1: 123.647,
    y1: 187.725,
    x2: 123.149,
    y2: 186.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_1136_96404",
    x1: 134.741,
    y1: 181.181,
    x2: 134.243,
    y2: 180.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_1136_96404",
    x1: 250.355,
    y1: 288.393,
    x2: 193.876,
    y2: 273.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_1136_96404",
    x1: 155.37,
    y1: 273.808,
    x2: 267.028,
    y2: 273.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_1136_96404",
    x1: 157.2,
    y1: 273.807,
    x2: 265.229,
    y2: 273.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_1136_96404",
    x1: 155.379,
    y1: 285.084,
    x2: 267.017,
    y2: 285.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_1136_96404",
    x1: 249.346,
    y1: 297.978,
    x2: 248.883,
    y2: 297.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_1136_96404",
    x1: 234.241,
    y1: 306.675,
    x2: 233.506,
    y2: 305.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_1136_96404",
    x1: 235.246,
    y1: 306.099,
    x2: 234.512,
    y2: 305.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_1136_96404",
    x1: 236.25,
    y1: 305.526,
    x2: 235.516,
    y2: 304.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_1136_96404",
    x1: 237.255,
    y1: 304.95,
    x2: 236.52,
    y2: 304.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_1136_96404",
    x1: 238.26,
    y1: 304.374,
    x2: 237.525,
    y2: 303.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_1136_96404",
    x1: 239.265,
    y1: 303.805,
    x2: 238.531,
    y2: 303.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_1136_96404",
    x1: 240.27,
    y1: 303.237,
    x2: 239.535,
    y2: 302.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_1136_96404",
    x1: 241.275,
    y1: 302.663,
    x2: 240.54,
    y2: 301.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_1136_96404",
    x1: 242.279,
    y1: 302.088,
    x2: 241.545,
    y2: 301.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_1136_96404",
    x1: 255.823,
    y1: 294.127,
    x2: 255.088,
    y2: 293.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_1136_96404",
    x1: 256.828,
    y1: 293.553,
    x2: 256.094,
    y2: 292.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_1136_96404",
    x1: 257.832,
    y1: 292.982,
    x2: 257.098,
    y2: 292.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_1136_96404",
    x1: 258.837,
    y1: 292.404,
    x2: 258.102,
    y2: 291.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_1136_96404",
    x1: 259.842,
    y1: 291.828,
    x2: 259.107,
    y2: 291.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_1136_96404",
    x1: 260.847,
    y1: 291.259,
    x2: 260.113,
    y2: 290.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_1136_96404",
    x1: 261.852,
    y1: 290.691,
    x2: 261.117,
    y2: 290.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_1136_96404",
    x1: 262.857,
    y1: 290.117,
    x2: 262.122,
    y2: 289.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_1136_96404",
    x1: 263.862,
    y1: 289.542,
    x2: 263.127,
    y2: 288.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_1136_96404",
    x1: 260.747,
    y1: 155.399,
    x2: 260.747,
    y2: 129.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_1136_96404",
    x1: 273.504,
    y1: 153.766,
    x2: 267.759,
    y2: 131.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_1136_96404",
    x1: 277.608,
    y1: 128.648,
    x2: 257.174,
    y2: 128.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_1136_96404",
    x1: 270.18,
    y1: 132.764,
    x2: 270.922,
    y2: 148.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A67B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_1136_96404",
    x1: 271.361,
    y1: 141.241,
    x2: 271.43,
    y2: 142.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_1136_96404",
    x1: 269.492,
    y1: 142.346,
    x2: 269.56,
    y2: 143.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_1136_96404",
    x1: 267.622,
    y1: 143.461,
    x2: 267.69,
    y2: 144.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_1136_96404",
    x1: 271.362,
    y1: 138.699,
    x2: 271.43,
    y2: 140.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_1136_96404",
    x1: 269.492,
    y1: 139.813,
    x2: 269.561,
    y2: 141.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_1136_96404",
    x1: 267.622,
    y1: 140.924,
    x2: 267.69,
    y2: 142.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_1136_96404",
    x1: 269.493,
    y1: 137.273,
    x2: 269.561,
    y2: 138.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E82FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#5A70FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_1136_96404",
    x1: 248.394,
    y1: 228.818,
    x2: 348.699,
    y2: 228.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9097C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#6770A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_1136_96404",
    x1: 57.2996,
    y1: 266.775,
    x2: 195.706,
    y2: 266.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9097C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#6770A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_1136_96404",
    x1: 154.078,
    y1: 234.547,
    x2: 176.527,
    y2: 234.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9097C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#6770A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_1136_96404",
    x1: 225.794,
    y1: 63,
    x2: 225.794,
    y2: 142.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D32F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D32F2F",
    stopOpacity: 0.85
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.ecb3e78e6d2eb4c6385ce4b236c8fae6.svg";
export { ForwardRef as ReactComponent };